/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var CollectionFilterTabs = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CollectionFilterTabs, _HTMLElement);
  var _super = _createSuper(CollectionFilterTabs);
  function CollectionFilterTabs() {
    var _this;
    _classCallCheck(this, CollectionFilterTabs);
    _this = _super.call(this);
    _this.filterForm = document.querySelector('form[is="facet-form"]');
    _this.activeTags = new Set();
    _this.isProcessing = false; // Prevent multiple rapid clicks
    _this.initActiveStates();
    _this.bindEvents();
    return _this;
  }
  _createClass(CollectionFilterTabs, [{
    key: "initActiveStates",
    value: function initActiveStates() {
      var _this2 = this;
      var url = new URL(window.location.href);
      var tagParams = url.searchParams.getAll("filter.p.tag");
      var allButton = this.querySelector('.filter-tab-button[data-tag="all"]');
      if (tagParams.length > 0) {
        tagParams.forEach(function (tag) {
          var button = _this2.querySelector(".filter-tab-button[data-tag=\"".concat(tag, "\"]"));
          if (button) {
            button.classList.add("is-active");
            _this2.activeTags.add(tag);
          }
        });
        if (allButton) allButton.classList.remove("is-active");
      } else if (allButton) {
        allButton.classList.add("is-active");
      }
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this3 = this;
      this.querySelectorAll(".filter-tab-button").forEach(function (button) {
        // Use both click and touchend for better mobile responsiveness
        button.addEventListener("click", _this3.onFilterButtonClick.bind(_this3));

        // Prevent default touch behaviors that might interfere
        button.addEventListener("touchstart", _this3.onTouchStart.bind(_this3), {
          passive: false
        });
        button.addEventListener("touchend", _this3.onTouchEnd.bind(_this3), {
          passive: false
        });

        // Prevent context menu on long press
        button.addEventListener("contextmenu", function (e) {
          return e.preventDefault();
        });
      });
    }
  }, {
    key: "onTouchStart",
    value: function onTouchStart(event) {
      // Store touch start time and position for gesture detection
      this.touchStartTime = Date.now();
      this.touchStartX = event.touches[0].clientX;
      this.touchStartY = event.touches[0].clientY;
    }
  }, {
    key: "onTouchEnd",
    value: function onTouchEnd(event) {
      // Only process if this is a tap (not a scroll gesture)
      if (event.changedTouches && event.changedTouches[0]) {
        var touchEndTime = Date.now();
        var touchEndX = event.changedTouches[0].clientX;
        var touchEndY = event.changedTouches[0].clientY;

        // Calculate distance moved and time elapsed
        var distance = Math.sqrt(Math.pow(touchEndX - this.touchStartX, 2) + Math.pow(touchEndY - this.touchStartY, 2));
        var timeElapsed = touchEndTime - this.touchStartTime;

        // Only treat as tap if it's quick and didn't move much (not a scroll)
        if (distance < 10 && timeElapsed < 500) {
          // Prevent the subsequent click event
          event.preventDefault();
          event.stopPropagation();

          // Add immediate visual feedback
          this.addTouchFeedback(event.target);

          // Manually trigger our filter logic
          this.onFilterButtonClick(event);
        }
      }
    }
  }, {
    key: "addTouchFeedback",
    value: function addTouchFeedback(button) {
      // Add a quick visual feedback for touch
      button.style.transform = 'scale(0.95)';
      button.style.transition = 'transform 0.1s ease';
      setTimeout(function () {
        button.style.transform = '';
        button.style.transition = '';
      }, 150);
    }
  }, {
    key: "onFilterButtonClick",
    value: function onFilterButtonClick(event) {
      var _this4 = this;
      // Prevent multiple rapid clicks
      if (this.isProcessing) {
        event.preventDefault();
        return;
      }
      this.isProcessing = true;

      // Add a small delay to prevent double-clicks
      setTimeout(function () {
        _this4.isProcessing = false;
      }, 300);
      event.preventDefault();
      var tagHandle = event.currentTarget.dataset.tag;
      var isAll = tagHandle === "all";
      var allButton = this.querySelector('.filter-tab-button[data-tag="all"]');
      if (isAll) {
        this.activeTags.clear();
        this.querySelectorAll(".filter-tab-button").forEach(function (btn) {
          return btn.classList.remove("is-active");
        });
        event.currentTarget.classList.add("is-active");
      } else {
        if (event.currentTarget.classList.contains("is-active")) {
          this.activeTags["delete"](tagHandle);
          event.currentTarget.classList.remove("is-active");
        } else {
          this.activeTags.add(tagHandle);
          event.currentTarget.classList.add("is-active");
        }
        if (this.activeTags.size === 0) {
          if (allButton) allButton.classList.add("is-active");
        } else if (allButton) {
          allButton.classList.remove("is-active");
        }
      }
      if (this.filterForm) {
        var url = this.buildTagFilterUrl();
        this.filterForm.renderSection(url, event);
      }
    }
  }, {
    key: "buildTagFilterUrl",
    value: function buildTagFilterUrl() {
      var url = new URL(window.location.origin + window.location.pathname);
      url.search = "";
      if (this.activeTags.size > 0) {
        this.activeTags.forEach(function (tag) {
          url.searchParams.append("filter.p.tag", tag);
        });
      }
      if (typeof FoxTheme !== "undefined" && FoxTheme.utils && FoxTheme.utils.getSectionId) {
        url.searchParams.set("section_id", FoxTheme.utils.getSectionId(this.filterForm));
      } else if (this.filterForm && this.filterForm.dataset.sectionId) {
        url.searchParams.set("section_id", this.filterForm.dataset.sectionId);
      }
      return url.toString();
    }
  }]);
  return CollectionFilterTabs;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element
customElements.define("collection-filter-tabs", CollectionFilterTabs);
var CollectionSpendTracker = /*#__PURE__*/function () {
  function CollectionSpendTracker() {
    _classCallCheck(this, CollectionSpendTracker);
    this.trackers = document.querySelectorAll("spend-tracker");
    if (this.trackers.length === 0) return;
    this.ensureSpendTrackerScriptLoaded();
  }
  _createClass(CollectionSpendTracker, [{
    key: "ensureSpendTrackerScriptLoaded",
    value: function ensureSpendTrackerScriptLoaded() {
      if (customElements.get("spend-tracker")) return;
      var script = document.createElement("script");
      script.src = window.theme.assets.spendTracker || "";
      script.defer = true;
      document.body.appendChild(script);
    }
  }]);
  return CollectionSpendTracker;
}(); // Initialize the spend tracker when DOM is loaded
document.addEventListener("DOMContentLoaded", function () {
  new CollectionSpendTracker();
});
if (!customElements.get("spend-tracker")) {
  customElements.define("spend-tracker", /*#__PURE__*/function (_HTMLElement2) {
    _inherits(SpendTracker, _HTMLElement2);
    var _super2 = _createSuper(SpendTracker);
    function SpendTracker() {
      var _this5;
      _classCallCheck(this, SpendTracker);
      _this5 = _super2.call(this);
      _this5.trackerWrapper = _this5.querySelector(".spend-tracker-wrapper");
      _this5.progressBar = _this5.querySelector(".spend-tracker-progress-bar");
      _this5.markers = _this5.querySelectorAll(".spend-tracker-marker");
      _this5.amountNeeded = _this5.querySelector(".spend-tracker-amount-needed");
      _this5.nextRewardText = _this5.querySelector(".spend-tracker-next-reward");
      _this5.moreTextSpan = _this5.querySelector(".more-text");
      _this5.completeTextSpan = _this5.querySelector(".complete-text");
      _this5.cartCountDisplay = _this5.querySelector(".cart-count");
      _this5.cartTotalDisplay = _this5.querySelector(".cart-total");
      _this5.closeButton = _this5.querySelector(".spend-tracker-close");
      _this5.viewCartButton = _this5.querySelector(".spend-tracker-view-cart");
      _this5.trackerMessage = _this5.querySelector(".spend-tracker-message");
      _this5.notificationTile = _this5.querySelector(".notification-tile");
      _this5.thresholds = [];
      _this5.currentTotal = 0;
      _this5.cartCount = 0;
      _this5.collectionId = _this5.dataset.collectionId;
      _this5.thresholdType = _this5.dataset.thresholdType;
      _this5.cartUrl = _this5.dataset.cartPage;
      _this5.storageKey = "spend-tracker-dismissed";
      _this5.addedFreeGifts = new Set();
      _this5.isInitialLoad = true;
      _this5.isLoaded = false;
      if (_this5.notificationTile) {
        _this5.notificationTile.style.display = "none";
      }
      _this5.initThresholds();
      _this5.bindEvents();
      return _this5;
    }
    _createClass(SpendTracker, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        if (localStorage.getItem(this.storageKey) === "true") {
          this.trackerWrapper.classList.add("hidden");
        }
        this.fetchCart();
        document.addEventListener("cart:updated", this.onCartUpdate.bind(this));
        if (typeof FoxTheme !== "undefined" && FoxTheme.pubsub) {
          this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
        }
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        document.removeEventListener("cart:updated", this.onCartUpdate.bind(this));
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
        if (this.closeButton) this.closeButton.removeEventListener("click", this.onCloseClick);
      }
    }, {
      key: "fetchCart",
      value: function fetchCart() {
        var _this6 = this;
        fetch("/cart.js").then(function (response) {
          return response.json();
        }).then(function (cart) {
          _this6.onCartUpdate({
            cart: cart
          });
          document.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              open: false
            }
          }));
        })["catch"](function (error) {
          console.error("Error fetching cart:", error);
        });
      }
    }, {
      key: "initThresholds",
      value: function initThresholds() {
        var _this7 = this;
        this.markers.forEach(function (marker) {
          var threshold = parseInt(marker.dataset.threshold, 10);
          var blockId = marker.dataset.id;
          var rewardDesc = marker.dataset.reward;
          var rewardType = marker.dataset.rewardType || "discount";
          var notificationText = "";
          if (rewardType === "discount") {
            notificationText = marker.dataset.percentage ? "".concat(marker.dataset.percentage, "%") : "";
          } else if (rewardType === "free_gift" || rewardType === "gift_with_percentage") {
            notificationText = rewardType === "free_gift" ? "Free Gift" : marker.dataset.percentage ? "".concat(marker.dataset.percentage, "% + Gift") : "Free Gift";
          }
          var freeGiftData = null;
          if (rewardType === "free_gift" || rewardType === "gift_with_percentage") {
            if (marker.dataset.giftVariantId) {
              freeGiftData = {
                title: rewardDesc.replace("Free gift: ", "").trim(),
                handle: marker.dataset.giftProductHandle || "",
                variantId: marker.dataset.giftVariantId
              };
            } else if (rewardDesc && rewardDesc.includes("::")) {
              var parts = rewardDesc.split("::");
              if (parts.length >= 2) {
                freeGiftData = {
                  title: parts[0].replace("Free gift: ", "").trim(),
                  handle: parts[1].trim(),
                  variantId: parts.length >= 3 ? parts[2].trim() : null
                };
              }
            }
          }
          _this7.thresholds.push({
            amount: threshold,
            blockId: blockId,
            element: marker,
            reward: rewardDesc,
            rewardType: rewardType,
            freeGift: freeGiftData,
            reached: false,
            notificationText: notificationText
          });
        });
        this.thresholds.sort(function (a, b) {
          return a.amount - b.amount;
        });
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        var _this8 = this;
        if (this.closeButton) {
          this.onCloseClick = function () {
            _this8.trackerWrapper.classList.add("hidden");
            localStorage.setItem(_this8.storageKey, "true");
          };
          this.closeButton.addEventListener("click", this.onCloseClick);
        }
        if (this.viewCartButton) {
          this.viewCartButton.addEventListener("click", this.onViewCartClick.bind(this));
        }
      }
    }, {
      key: "onViewCartClick",
      value: function onViewCartClick(event) {
        event.preventDefault();
        var cartDrawerButton = document.querySelector('.cart-drawer-button, .js-cart-drawer-trigger, [data-action="open-drawer"][data-drawer-id="cart"], [data-cart-drawer-toggle]');
        if (cartDrawerButton) {
          cartDrawerButton.click();
        } else {
          document.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              open: true
            }
          }));
          if (typeof FoxTheme !== "undefined" && FoxTheme.pubsub) {
            FoxTheme.pubsub.publish("cart:open", {});
          }
          if (!document.querySelector('.cart-drawer.active, .cart-drawer.is-open, .cart-drawer[aria-hidden="false"]')) {
            window.location.href = this.cartUrl || "/cart";
          }
        }
      }
    }, {
      key: "onCartUpdate",
      value: function onCartUpdate(event) {
        var _this9 = this;
        if (!event.cart) return;
        var relevantTotal = 0;
        this.cartCount = event.cart.item_count || 0;
        if (this.thresholdType === "collection" && this.collectionId !== "all") {
          var collectionId = Number(this.collectionId);
          event.cart.items.forEach(function (item) {
            if (item.product_collections && item.product_collections.includes(collectionId)) {
              relevantTotal += item.final_line_price;
            }
          });
        } else {
          relevantTotal = event.cart.items_subtotal_price || event.cart.total_price || 0;
        }
        this.updateTracker(relevantTotal);
        this.updateCartDisplay(event.cart);
        if (!this.isLoaded) {
          this.isLoaded = true;
          setTimeout(function () {
            _this9.classList.add("is-loaded");
            setTimeout(function () {
              _this9.isInitialLoad = false;
            }, 1000);
          }, 300);
        }
      }
    }, {
      key: "updateCartDisplay",
      value: function updateCartDisplay(cart) {
        this.cartCountDisplay.textContent = this.cartCount;
        this.cartTotalDisplay.textContent = this.formatMoney(cart.total_price || 0);
      }
    }, {
      key: "updateTracker",
      value: function updateTracker(amount) {
        var _this10 = this;
        this.currentTotal = amount / 100;
        var maxThreshold = Math.max.apply(Math, _toConsumableArray(this.thresholds.map(function (t) {
          return t.amount / 100;
        })).concat([1]));
        var progressPercent = Math.min(100, this.currentTotal / maxThreshold * 100);
        this.progressBar.style.setProperty("--progress-width", "".concat(progressPercent, "%"));
        var newlyReachedThresholds = [];
        var allThresholdsReached = true;
        var highestReachedThreshold = null;
        this.thresholds.forEach(function (threshold) {
          var isReached = _this10.currentTotal >= threshold.amount / 100;
          if (!isReached) {
            allThresholdsReached = false;
          } else if (!highestReachedThreshold || threshold.amount > highestReachedThreshold.amount) {
            highestReachedThreshold = threshold;
          }
          if (isReached !== threshold.reached) {
            if (isReached && !threshold.reached && !_this10.isInitialLoad) {
              newlyReachedThresholds.push(threshold);
            }
            threshold.reached = isReached;
            if (isReached) {
              threshold.element.classList.add("active");
              if (!_this10.isInitialLoad) {
                threshold.element.classList.add("threshold-reached");
                setTimeout(function () {
                  threshold.element.classList.remove("threshold-reached");
                }, 500);
              }
            } else {
              threshold.element.classList.remove("active");
            }
          }
        });
        this.updateNotificationTile(highestReachedThreshold);
        if (newlyReachedThresholds.length > 0 && !this.isInitialLoad) {
          this.processFreeGiftThresholds(newlyReachedThresholds);
        }
        this.updateProgressMessage(allThresholdsReached);
      }
    }, {
      key: "updateNotificationTile",
      value: function updateNotificationTile(threshold) {
        if (!this.notificationTile) return;
        if (!threshold) {
          this.notificationTile.style.display = "none";
          return;
        }
        if (threshold.rewardType === "discount") {
          this.notificationTile.textContent = threshold.notificationText;
        } else if (threshold.rewardType === "free_gift") {
          this.notificationTile.textContent = "Gift";
        } else if (threshold.rewardType === "gift_with_percentage") {
          this.notificationTile.textContent = threshold.notificationText || "Gift + %";
        }
        this.notificationTile.style.display = "flex";
      }
    }, {
      key: "processFreeGiftThresholds",
      value: function processFreeGiftThresholds(thresholds) {
        var _this11 = this;
        if (this.isInitialLoad) return;
        fetch("/cart.js").then(function (response) {
          return response.json();
        }).then(function (cart) {
          var freeGiftThresholds = thresholds.filter(function (threshold) {
            var hasFreeGift = threshold.rewardType === "free_gift" || threshold.rewardType === "gift_with_percentage";
            var hasFreeGiftData = threshold.freeGift && threshold.freeGift.variantId;
            var notAlreadyAdded = !_this11.addedFreeGifts.has(threshold.blockId);
            return hasFreeGift && hasFreeGiftData && notAlreadyAdded;
          });
          if (freeGiftThresholds.length === 0) return;
          var addGiftPromises = freeGiftThresholds.map(function (threshold) {
            var isGiftInCart = _this11.isGiftAlreadyInCart(threshold, cart);
            if (!isGiftInCart) {
              return _this11.addFreeGiftToCart(threshold, cart);
            } else {
              _this11.addedFreeGifts.add(threshold.blockId);
              return Promise.resolve();
            }
          });
          Promise.all(addGiftPromises).then(function () {
            _this11.fetchCart();
            document.dispatchEvent(new CustomEvent("gift:added", {
              bubbles: true,
              detail: {
                thresholds: freeGiftThresholds
              }
            }));
          })["catch"](function (error) {
            console.error("Error processing free gift additions:", error);
          });
        })["catch"](function (error) {
          console.error("Error fetching cart to check for free gifts:", error);
        });
      }
    }, {
      key: "isGiftAlreadyInCart",
      value: function isGiftAlreadyInCart(threshold, cart) {
        if (!threshold.freeGift || !threshold.freeGift.variantId || !cart.items) {
          return false;
        }
        var variantId = threshold.freeGift.variantId;
        return cart.items.some(function (item) {
          return item.variant_id == variantId && item.properties && (item.properties["_free_gift"] === "true" || item.properties["_threshold_gift"] === threshold.blockId);
        });
      }
    }, {
      key: "addFreeGiftToCart",
      value: function addFreeGiftToCart(threshold, cart) {
        var _this12 = this;
        if (!threshold.freeGift) {
          return Promise.reject("Missing free gift data");
        }
        var variantId = threshold.freeGift.variantId;
        if (!variantId) {
          return Promise.reject("Missing variant ID");
        }
        var formData = {
          items: [{
            id: variantId,
            quantity: 1,
            properties: {
              _free_gift: "true",
              _threshold_gift: threshold.blockId,
              _threshold_amount: "$".concat((threshold.amount / 100).toFixed(2))
            }
          }]
        };
        return fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(formData)
        }).then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || "HTTP error! status: ".concat(response.status));
            });
          }
          return response.json();
        }).then(function (data) {
          _this12.addedFreeGifts.add(threshold.blockId);
          _this12.updateCartCountDisplay(cart.item_count + 1);
          return data;
        })["catch"](function (error) {
          console.error("Error adding free gift to cart:", error);
          _this12.addedFreeGifts["delete"](threshold.blockId);
          throw error;
        });
      }
    }, {
      key: "updateCartCountDisplay",
      value: function updateCartCountDisplay(count) {
        document.querySelectorAll(".cart-count").forEach(function (element) {
          element.textContent = count;
        });
        var headerCartCount = document.querySelector(".header__cart-count");
        if (headerCartCount) {
          headerCartCount.textContent = count;
        }
      }
    }, {
      key: "updateProgressMessage",
      value: function updateProgressMessage(allReached) {
        if (allReached && this.thresholds.length > 0) {
          if (this.moreTextSpan) this.moreTextSpan.style.display = "none";
          if (this.completeTextSpan) this.completeTextSpan.style.display = "inline";
          return;
        }
        if (this.moreTextSpan) this.moreTextSpan.style.display = "inline";
        if (this.completeTextSpan) this.completeTextSpan.style.display = "none";
        var nextThreshold = this.thresholds.find(function (t) {
          return !t.reached;
        });
        if (nextThreshold) {
          var amountNeeded = nextThreshold.amount / 100 - this.currentTotal;
          if (this.amountNeeded) {
            this.amountNeeded.textContent = this.formatMoney(amountNeeded * 100).replace(".00", "") + " more";
            this.amountNeeded.classList.add("highlight");
          }
          if (this.nextRewardText) {
            if (nextThreshold.rewardType === "free_gift" && nextThreshold.freeGift) {
              this.nextRewardText.textContent = "Free Gift";
            } else if (nextThreshold.rewardType === "gift_with_percentage" && nextThreshold.freeGift) {
              var percentage = nextThreshold.element.dataset.percentage;
              this.nextRewardText.textContent = percentage ? "".concat(percentage, "% + Gift") : "Free Gift";
            } else if (nextThreshold.reward) {
              this.nextRewardText.textContent = nextThreshold.reward.split(":")[0].trim();
            } else if (nextThreshold.element.dataset.percentage) {
              this.nextRewardText.textContent = "".concat(nextThreshold.element.dataset.percentage, "% Off");
            } else {
              var labelEl = nextThreshold.element.querySelector(".spend-tracker-marker-label");
              if (labelEl) {
                this.nextRewardText.textContent = labelEl.textContent;
              }
            }
            this.nextRewardText.classList.add("highlight");
          }
        }
      }
    }, {
      key: "formatMoney",
      value: function formatMoney(cents) {
        if (typeof FoxTheme !== "undefined" && FoxTheme.Currency && FoxTheme.Currency.formatMoney) {
          return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
        }
        return "$" + (cents / 100).toFixed(2);
      }
    }]);
    return SpendTracker;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement)));
}
var ProductCardQuantityControl = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(ProductCardQuantityControl, _HTMLElement3);
  var _super3 = _createSuper(ProductCardQuantityControl);
  function ProductCardQuantityControl() {
    var _this13;
    _classCallCheck(this, ProductCardQuantityControl);
    _this13 = _super3.call(this);
    _this13.productId = _this13.dataset.productId;
    _this13.variantId = _this13.dataset.variantId;
    _this13.quantity = 1;
    _this13.minimumQuantity = Number(_this13.dataset.minimum || 1);
    _this13.thresholdContext = _this13.hasAttribute("data-threshold-context");
    _this13.isAddingToCart = false;
    return _this13;
  }
  _createClass(ProductCardQuantityControl, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      if ((name === "data-variant-id" || name === "data-product-id") && oldValue !== newValue) {
        if (name === "data-variant-id") this.variantId = newValue;
        if (name === "data-product-id") this.productId = newValue;
        this.updateButtonState();
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this14 = this;
      this.quantitySelector = this.querySelector(".quantity-selector");
      this.addToCartButton = this.querySelector(".add-to-cart-button");
      this.quantityInput = this.querySelector(".quantity-selector__input");
      this.hiddenQuantityInput = this.querySelector(".quantity-input-hidden");
      this.productForm = this.querySelector("form");
      this.thresholdComponentExists = document.querySelector("spend-tracker") !== null;
      this.bindEvents();
      if (this.quantitySelector) this.quantitySelector.classList.add("hidden");
      if (this.thresholdComponentExists) {
        this.checkCartContents();
        this.updateButtonState();
        document.addEventListener("cart:updated", function (event) {
          if (event.detail && event.detail.cart) {
            var cartItem = event.detail.cart.items.find(function (item) {
              return item.variant_id == _this14.variantId;
            });
            if (cartItem) {
              _this14.quantity = cartItem.quantity;
              if (_this14.quantityInput) {
                _this14.quantityInput.value = _this14.quantity;
              }
              if (_this14.thresholdContext && _this14.quantitySelector && _this14.addToCartButton) {
                _this14.quantitySelector.classList.remove("hidden");
                _this14.addToCartButton.classList.add("hidden");
              }
            } else if (_this14.thresholdContext) {
              if (_this14.quantitySelector) _this14.quantitySelector.classList.add("hidden");
              if (_this14.addToCartButton) _this14.addToCartButton.classList.remove("hidden");
            }
          }
        });
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.quantityInput) {
        this.quantityInput.removeEventListener("change", this._handleQuantityChange);
      }
      this.removeEventListener("click", this._handleClick);
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      this._handleClick = this.handleClick.bind(this);
      this._handleQuantityChange = this.handleQuantityChange.bind(this);
      this.addEventListener("click", this._handleClick);
      if (this.quantityInput) {
        this.quantityInput.addEventListener("change", this._handleQuantityChange);
      }
    }
  }, {
    key: "handleQuantityChange",
    value: function handleQuantityChange(event) {
      var newQuantity = parseInt(event.target.value, 10);
      this.quantity = isNaN(newQuantity) ? 1 : Math.max(this.minimumQuantity, newQuantity);
      this.quantityInput.value = this.quantity;
      if (this.hiddenQuantityInput) {
        this.hiddenQuantityInput.value = this.quantity;
      }
      if (this.quantity > 0 && !this.quantitySelector.classList.contains("hidden")) {
        this.updateCart();
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var _this15 = this;
      var target = event.target;
      if (target.classList.contains("quantity__button--minus") || target.classList.contains("quantity-selector__button") && target.textContent.includes("−")) {
        event.preventDefault();
        this.decreaseQuantity();
        this.updateCart();
        return;
      }
      if (target.classList.contains("quantity__button--plus") || target.classList.contains("quantity-selector__button") && target.textContent.includes("+")) {
        event.preventDefault();
        this.increaseQuantity();
        this.updateCart();
        return;
      }
      if (target.classList.contains("add-to-cart-button") || target.closest(".add-to-cart-button")) {
        event.preventDefault();
        if (this.thresholdContext) {
          this.quantity = 1;
          if (this.quantityInput) {
            this.quantityInput.value = 1;
          }
          this.addToCart(1);
          setTimeout(function () {
            _this15.toggleQuantitySelector();
          }, 100);
        } else {
          this.addToCart(1);
        }
      }
    }
  }, {
    key: "toggleQuantitySelector",
    value: function toggleQuantitySelector() {
      if (this.quantitySelector && this.addToCartButton && this.thresholdComponentExists) {
        this.quantitySelector.classList.toggle("hidden");
        this.addToCartButton.classList.toggle("hidden");
        if (!this.quantitySelector.classList.contains("hidden")) {
          this.quantityInput.focus();
        }
      }
    }
  }, {
    key: "decreaseQuantity",
    value: function decreaseQuantity() {
      var newQuantity = Number(this.quantityInput.value) - 1;
      if (newQuantity < this.minimumQuantity) {
        if (this.thresholdContext) {
          this.removeFromCart();
          return;
        }
      } else {
        this.quantityInput.value = newQuantity;
        this.quantity = newQuantity;
        if (this.hiddenQuantityInput) {
          this.hiddenQuantityInput.value = newQuantity;
        }
      }
    }
  }, {
    key: "increaseQuantity",
    value: function increaseQuantity() {
      var newQuantity = Number(this.quantityInput.value) + 1;
      this.quantityInput.value = newQuantity;
      this.quantity = newQuantity;
      if (this.hiddenQuantityInput) {
        this.hiddenQuantityInput.value = newQuantity;
      }
    }
  }, {
    key: "updateButtonState",
    value: function updateButtonState() {
      // Additional logic can be added here
    }
  }, {
    key: "checkCartContents",
    value: function checkCartContents() {
      var _this16 = this;
      fetch("/cart.js").then(function (response) {
        if (!response.ok) throw new Error("HTTP error! status: ".concat(response.status));
        return response.json();
      }).then(function (cart) {
        var cartItem = cart.items.find(function (item) {
          return item.variant_id == _this16.variantId;
        });
        if (cartItem) {
          _this16.quantity = cartItem.quantity;
          if (_this16.quantityInput) {
            _this16.quantityInput.value = _this16.quantity;
          }
          if (_this16.thresholdContext && _this16.quantity > 0) {
            if (_this16.quantitySelector) _this16.quantitySelector.classList.remove("hidden");
            if (_this16.addToCartButton) _this16.addToCartButton.classList.add("hidden");
          }
        }
      })["catch"](function (error) {
        console.error("Error fetching cart:", error);
      });
    }
  }, {
    key: "updateCart",
    value: function updateCart() {
      if (this.quantity <= 0) {
        this.removeFromCart();
      } else {
        this.changeItemQuantity(this.quantity);
      }
    }
  }, 
  {
    key: "addToCart",
    value: function addToCart(quantity) {
      var _this17 = this;
      if (this.isAddingToCart) return;
      this.isAddingToCart = true;
      if (this.addToCartButton) {
        this.addToCartButton.classList.add("loading");
        this.addToCartButton.setAttribute("disabled", "disabled");
      }
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          items: [{
            id: this.variantId,
            quantity: quantity || this.quantity || 1
          }],
          sections: "cart-drawer,cart-icon-bubble"
        })
      }).then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || "HTTP error! status: ".concat(response.status));
          });
        }
        return response.json();
      }).then(function (data) {
        _this17.quantity = quantity || _this17.quantity || 1;
        if (_this17.quantityInput) {
          _this17.quantityInput.value = _this17.quantity;
        }
        _this17.refreshCart();
        if (_this17.thresholdContext && _this17.quantitySelector && _this17.addToCartButton && _this17.thresholdComponentExists) {
          _this17.quantitySelector.classList.remove("hidden");
          _this17.addToCartButton.classList.add("hidden");
        }
      })["catch"](function (error) {
        console.error("Error adding product to cart:", error);
        alert(error.message || "Could not add item to cart. Please try again.");
      })["finally"](function () {
        _this17.isAddingToCart = false;
        if (_this17.addToCartButton) {
          _this17.addToCartButton.classList.remove("loading");
          _this17.addToCartButton.removeAttribute("disabled");
        }
      });
    }
  }, 
  {
    key: "changeItemQuantity",
    value: function changeItemQuantity(newQuantity) {
      var _this18 = this;
      if (this.isAddingToCart) return;
      this.isAddingToCart = true;
      if (this.quantitySelector) {
        this.quantitySelector.classList.add("loading");
      }
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: this.getCartLineItemKey(),
          quantity: newQuantity,
          sections: "cart-drawer,cart-icon-bubble"
        })
      }).then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || "HTTP error! status: ".concat(response.status));
          });
        }
        return response.json();
      }).then(function (cart) {
        var cartItem = cart.items.find(function (item) {
          return item.variant_id == _this18.variantId;
        });
        if (cartItem) {
          _this18.quantity = cartItem.quantity;
          if (_this18.quantityInput) {
            _this18.quantityInput.value = _this18.quantity;
          }
        }
        _this18.triggerCartUpdateEvent(cart);
      })["catch"](function (error) {
        console.error("Error changing item quantity:", error);
        if (_this18.quantityInput) {
          _this18.quantityInput.value = _this18.quantity;
        }
      })["finally"](function () {
        _this18.isAddingToCart = false;
        if (_this18.quantitySelector) {
          _this18.quantitySelector.classList.remove("loading");
        }
      });
    }
  }, {
    key: "removeFromCart",
    value: function removeFromCart() {
      var _this19 = this;
      if (this.isAddingToCart) return;
      this.isAddingToCart = true;
      if (this.quantitySelector) {
        this.quantitySelector.classList.add("loading");
      }
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: this.getCartLineItemKey(),
          quantity: 0,
          sections: "cart-drawer,cart-icon-bubble"
        })
      }).then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || "HTTP error! status: ".concat(response.status));
          });
        }
        return response.json();
      }).then(function (cart) {
        _this19.quantity = _this19.minimumQuantity;
        if (_this19.quantityInput) {
          _this19.quantityInput.value = _this19.minimumQuantity;
        }
        _this19.triggerCartUpdateEvent(cart);
        if (_this19.thresholdContext) {
          if (_this19.quantitySelector) _this19.quantitySelector.classList.add("hidden");
          if (_this19.addToCartButton) _this19.addToCartButton.classList.remove("hidden");
        }
      })["catch"](function (error) {
        console.error("Error removing item from cart:", error);
      })["finally"](function () {
        _this19.isAddingToCart = false;
        if (_this19.quantitySelector) {
          _this19.quantitySelector.classList.remove("loading");
        }
      });
    }
  }, {
    key: "refreshCart",
    value: function refreshCart() {
      var _this20 = this;
      fetch("/cart.js").then(function (response) {
        if (!response.ok) throw new Error("HTTP error! status: ".concat(response.status));
        return response.json();
      }).then(function (cart) {
        _this20.triggerCartUpdateEvent(cart);
      })["catch"](function (error) {
        console.error("Error refreshing cart:", error);
      });
    }
  }, {
    key: "getCartLineItemKey",
    value: function getCartLineItemKey() {
      return this._cartItemKey || this.variantId;
    }
  }, {
    key: "triggerCartUpdateEvent",
    value: function triggerCartUpdateEvent(cart) {
      var _this21 = this;
      var cartItem = cart.items.find(function (item) {
        return item.variant_id == _this21.variantId;
      });
      if (cartItem) {
        this._cartItemKey = cartItem.key;
      }
      document.dispatchEvent(new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: cart
        }
      }));
      document.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          open: !this.thresholdComponentExists
        }
      }));
      if (typeof FoxTheme !== "undefined" && FoxTheme.pubsub) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          cart: cart
        });
      }
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["data-variant-id", "data-product-id"];
    }
  }]);
  return ProductCardQuantityControl;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element
if (!customElements.get("product-card-quantity-control")) {
  customElements.define("product-card-quantity-control", ProductCardQuantityControl);
}
var SellingPlanSelector = /*#__PURE__*/function (_HTMLElement4) {
  _inherits(SellingPlanSelector, _HTMLElement4);
  var _super4 = _createSuper(SellingPlanSelector);
  function SellingPlanSelector() {
    var _this22$deliveryButto;
    var _this22;
    _classCallCheck(this, SellingPlanSelector);
    _this22 = _super4.call(this);
    _this22.deliveryButton = _this22.querySelector(".btn-cart-check-delevery");
    _this22.selectedFrequencies = _this22.querySelector("selected-frequencies");
    _this22.frequencyOptions = _this22.querySelectorAll(".selected-plan_option");
    _this22.btnTextCurrent = (_this22$deliveryButto = _this22.deliveryButton) === null || _this22$deliveryButto === void 0 ? void 0 : _this22$deliveryButto.querySelector(".btn__text-current");
    _this22.closeBtn = _this22.querySelector(".check-rotated");
    _this22.isUpdatingCart = false;
    _this22.bindEvents();
    // Initialize from stored frequency if available
    _this22.initFromStoredFrequency();
    return _this22;
  }
  _createClass(SellingPlanSelector, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this23 = this;
      if (this.deliveryButton) {
        this.deliveryButton.addEventListener("click", this.toggleFrequencies.bind(this));
      }
      if (this.closeBtn) {
        this.closeBtn.addEventListener("click", this.closeFrequencies.bind(this));
      }
      if (this.frequencyOptions) {
        this.frequencyOptions.forEach(function (option) {
          option.addEventListener("click", _this23.selectFrequency.bind(_this23));
        });
      }
      document.addEventListener("cart:updated", function () {
        // Check if postcode is entered - if so, enable the delivery button
        if (sessionStorage.getItem("bmp-postcode")) {
          if (_this23.deliveryButton) {
            _this23.deliveryButton.removeAttribute("disabled");
          }
        }

        // Auto-apply selected frequency to new cart items
        _this23.autoApplyFrequencyToNewItems();

        // Clear stored frequency if cart becomes empty
        _this23.checkEmptyCart();
      });

      // Listen for sellingPlan:cart:refresh to check cart value and delivery
      document.addEventListener("sellingPlan:cart:refresh", function () {
        _this23.checkCartForCheckoutEnable();
      });

      // Also listen to FoxTheme pubsub cart updates for broader compatibility
      if (typeof FoxTheme !== "undefined" && FoxTheme.pubsub) {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function () {
          // Auto-apply selected frequency to new cart items
          _this23.autoApplyFrequencyToNewItems();
        });
      }
    }
  }, {
    key: "toggleFrequencies",
    value: function toggleFrequencies(event) {
      event.preventDefault();
      if (this.selectedFrequencies && this.deliveryButton) {
        // Toggle visibility
        this.selectedFrequencies.classList.toggle("hidden");
        this.deliveryButton.classList.toggle("hidden");

        // Ensure loading class is removed
        this.deliveryButton.classList.remove("loading");
        if (!this.selectedFrequencies.classList.contains("hidden")) {
          // If showing the frequency options, ensure they are visible
          this.selectedFrequencies.classList.remove("hidden");
          this.deliveryButton.classList.add("hidden");
        }
      }
    }
  }, {
    key: "closeFrequencies",
    value: function closeFrequencies() {
      if (this.selectedFrequencies && this.deliveryButton) {
        this.selectedFrequencies.classList.add("hidden");
        this.deliveryButton.classList.remove("hidden");
      }
    }

    // Keep the method but don't call it in constructor
  }, {
    key: "initSelectedFrequency",
    value: function initSelectedFrequency() {
      var _this24 = this;
      // Check if a selling plan is already selected in cart to update button display
      fetch("/cart.js").then(function (response) {
        return response.json();
      }).then(function (cart) {
        if (cart.items && cart.items.length > 0) {
          // Check the first item's selling plan to determine current selection
          var firstItem = cart.items.find(function (item) {
            return item.selling_plan_allocation;
          });
          if (firstItem && firstItem.selling_plan_allocation) {
            var sellingPlanName = firstItem.selling_plan_allocation.selling_plan.name.toLowerCase();
            var selectedOption = null;
            if (sellingPlanName.includes("1 week")) {
              var _selectedOption;
              selectedOption = _this24.querySelector('.selected-plan_option[value="oneweek"]');
              _this24.updateSelectedDisplay("oneweek", ((_selectedOption = selectedOption) === null || _selectedOption === void 0 ? void 0 : _selectedOption.innerHTML) || "Weekly (Save 10%)");
            } else if (sellingPlanName.includes("2 week")) {
              var _selectedOption2;
              selectedOption = _this24.querySelector('.selected-plan_option[value="twoweek"]');
              _this24.updateSelectedDisplay("twoweek", ((_selectedOption2 = selectedOption) === null || _selectedOption2 === void 0 ? void 0 : _selectedOption2.innerHTML) || "Fortnightly (Save 10%)");
            }
            if (selectedOption) {
              _this24.deliveryButton.classList.add("checker-completed");
            }
          }
        }
      })["catch"](function (error) {
        console.error("Error checking cart for selling plans:", error);
      });
    }
  }, {
    key: "selectFrequency",
    value: function selectFrequency(event) {
      var _this25 = this;
      if (this.isUpdatingCart) return;
      var selectedOption = event.currentTarget;
      var frequencyType = selectedOption.getAttribute("value");
      var selectedText = selectedOption.innerHTML;

      // Update display to show selected frequency
      this.updateSelectedDisplay(frequencyType, selectedText);

      // Add loading state to button before updating
      if (this.deliveryButton) {
        this.deliveryButton.classList.add("loading");
      }

      // Update all items in cart with the selected selling plan
      this.updateCartSellingPlan(frequencyType).then(function () {
        // Update display to show selected frequency
        // this.updateSelectedDisplay(frequencyType, selectedText);

        // Refresh the cart to update UI
        _this25.refreshCart();
      })["catch"](function (error) {
        console.error("Error updating cart with selling plan:", error);
        // Remove loading state in case of error
        if (_this25.deliveryButton) {
          _this25.deliveryButton.classList.remove("loading");
        }
      });
    }
  }, {
    key: "updateSelectedDisplay",
    value: function updateSelectedDisplay(frequencyType, selectedText) {
      // Hide frequency options and show button with updated text
      if (this.selectedFrequencies && this.deliveryButton) {
        this.selectedFrequencies.classList.add("hidden");
        this.deliveryButton.classList.remove("hidden");
        // Remove loading state if it exists
        this.deliveryButton.classList.remove("loading");

        // Update button text to show selected frequency
        if (this.btnTextCurrent) {
          this.btnTextCurrent.innerHTML = selectedText;
        }

        // Add class to indicate selection was made
        this.deliveryButton.classList.add("checker-completed");

        // Store or clear selection in session storage
        if (frequencyType === "onetime") {
          // Clear stored frequency for one-time purchases
          sessionStorage.removeItem("bmp-selected-frequency");
          sessionStorage.removeItem("bmp-selected-frequency-text");
        } else {
          // Store selection for subscriptions
          sessionStorage.setItem("bmp-selected-frequency", frequencyType);
          sessionStorage.setItem("bmp-selected-frequency-text", selectedText);
        }
      }
    }
  }, {
    key: "updateCartSellingPlan",
    value: function () {
      var _updateCartSellingPlan = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(frequencyType) {
        var updateSuccessful, cartResponse, cart, sellingPlanSelects, updates, _iterator, _step, _loop, _iterator2, _step2, update;
        return _regeneratorRuntime().wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.isUpdatingCart = true;
              updateSuccessful = false;
              _context2.prev = 2;
              _context2.next = 5;
              return fetch("/cart.js");
            case 5:
              cartResponse = _context2.sent;
              _context2.next = 8;
              return cartResponse.json();
            case 8:
              cart = _context2.sent;
              // Get all hidden selling plan selects in the cart
              sellingPlanSelects = document.querySelectorAll(".cart-selling-plan-selection");
              if (!(sellingPlanSelects.length === 0)) {
                _context2.next = 13;
                break;
              }
              console.warn("No selling plan selectors found in the cart");
              return _context2.abrupt("return", false);
            case 13:
              // Map to store item keys and their corresponding selling plan IDs for batch update
              updates = []; // Process each item in the cart
              _iterator = _createForOfIteratorHelper(cart.items);
              _context2.prev = 15;
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var item, matchingSelect, sellingPlanId, onetimeOption, option;
                return _regeneratorRuntime().wrap(function _loop$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      item = _step.value;
                      // Find the matching select for this item based on data-item-key or data-item-id
                      matchingSelect = Array.from(sellingPlanSelects).find(function (select) {
                        return select.getAttribute("data-item-key") === item.key || select.getAttribute("data-item-id") == item.id;
                      });
                      if (matchingSelect) {
                        sellingPlanId = "";
                        if (frequencyType === "onetime") {
                          // For one-time purchase, find the onetime option
                          onetimeOption = matchingSelect.querySelector(".selling_plan_onetime"); // One-time purchase might not have a selling plan ID, or it might be empty
                          sellingPlanId = onetimeOption ? onetimeOption.value : "";
                        } else {
                          // Find option with class matching the frequency type
                          option = matchingSelect.querySelector(".selling_plan_".concat(frequencyType));
                          if (option) {
                            sellingPlanId = option.value;
                          }
                        }

                        // Add to updates if we have a valid key
                        updates.push({
                          id: item.key,
                          quantity: item.quantity,
                          selling_plan: sellingPlanId
                        });
                      }
                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }, _loop);
              });
              _iterator.s();
            case 18:
              if ((_step = _iterator.n()).done) {
                _context2.next = 22;
                break;
              }
              return _context2.delegateYield(_loop(), "t0", 20);
            case 20:
              _context2.next = 18;
              break;
            case 22:
              _context2.next = 27;
              break;
            case 24:
              _context2.prev = 24;
              _context2.t1 = _context2["catch"](15);
              _iterator.e(_context2.t1);
            case 27:
              _context2.prev = 27;
              _iterator.f();
              return _context2.finish(27);
            case 30:
              if (!(updates.length > 0)) {
                _context2.next = 49;
                break;
              }
              // For better user experience, we'll update each item individually
              // and show the loading state on the button during this process
              _iterator2 = _createForOfIteratorHelper(updates);
              _context2.prev = 32;
              _iterator2.s();
            case 34:
              if ((_step2 = _iterator2.n()).done) {
                _context2.next = 40;
                break;
              }
              update = _step2.value;
              _context2.next = 38;
              return fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(update)
              }).then(function (response) {
                return response.json();
              });
            case 38:
              _context2.next = 34;
              break;
            case 40:
              _context2.next = 45;
              break;
            case 42:
              _context2.prev = 42;
              _context2.t2 = _context2["catch"](32);
              _iterator2.e(_context2.t2);
            case 45:
              _context2.prev = 45;
              _iterator2.f();
              return _context2.finish(45);
            case 48:
              updateSuccessful = true;
            case 49:
              _context2.next = 55;
              break;
            case 51:
              _context2.prev = 51;
              _context2.t3 = _context2["catch"](2);
              console.error("Error updating cart with selling plan:", _context2.t3);
              updateSuccessful = false;
            case 55:
              _context2.prev = 55;
              this.isUpdatingCart = false;
              // Remove loading state
              if (this.deliveryButton) {
                this.deliveryButton.classList.remove("loading");
              }
              return _context2.abrupt("return", updateSuccessful);
            case 60:
            case "end":
              return _context2.stop();
          }
        }, _callee, this, [[2, 51, 55, 60], [15, 24, 27, 30], [32, 42, 45, 48]]);
      }));
      function updateCartSellingPlan(_x) {
        return _updateCartSellingPlan.apply(this, arguments);
      }
      return updateCartSellingPlan;
    }()
  }, {
    key: "autoApplyFrequencyToNewItems",
    value: function () {
      var _autoApplyFrequencyToNewItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this26 = this;
        var storedFrequency, cartResponse, cart, sellingPlanSelects, updates, _iterator3, _step3, _loop2, _ret, _iterator4, _step4, update;
        return _regeneratorRuntime().wrap(function _callee2$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // Only run if we have a stored frequency selection and not currently updating cart
              storedFrequency = sessionStorage.getItem("bmp-selected-frequency");
              if (!(!storedFrequency || this.isUpdatingCart || storedFrequency === "onetime")) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return");
            case 3:
              _context4.prev = 3;
              _context4.next = 6;
              return fetch("/cart.js");
            case 6:
              cartResponse = _context4.sent;
              _context4.next = 9;
              return cartResponse.json();
            case 9:
              cart = _context4.sent;
              // Get all selling plan selects in the cart
              sellingPlanSelects = document.querySelectorAll(".cart-selling-plan-selection");
              if (!(sellingPlanSelects.length === 0)) {
                _context4.next = 13;
                break;
              }
              return _context4.abrupt("return");
            case 13:
              updates = []; // Check each cart item to see if it needs the selling plan applied
              _iterator3 = _createForOfIteratorHelper(cart.items);
              _context4.prev = 15;
              _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2() {
                var item, matchingSelect, option;
                return _regeneratorRuntime().wrap(function _loop2$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      item = _step3.value;
                      if (!item.selling_plan_allocation) {
                        _context3.next = 3;
                        break;
                      }
                      return _context3.abrupt("return", "continue");
                    case 3:
                      // Find the matching select for this item
                      matchingSelect = Array.from(sellingPlanSelects).find(function (select) {
                        return select.getAttribute("data-item-key") === item.key || select.getAttribute("data-item-id") == item.id;
                      });
                      if (matchingSelect) {
                        // Find the option with the stored frequency type
                        option = matchingSelect.querySelector(".selling_plan_".concat(storedFrequency));
                        if (option && option.value) {
                          updates.push({
                            id: item.key,
                            quantity: item.quantity,
                            selling_plan: option.value
                          });
                        }
                      }
                    case 5:
                    case "end":
                      return _context3.stop();
                  }
                }, _loop2);
              });
              _iterator3.s();
            case 18:
              if ((_step3 = _iterator3.n()).done) {
                _context4.next = 25;
                break;
              }
              return _context4.delegateYield(_loop2(), "t0", 20);
            case 20:
              _ret = _context4.t0;
              if (!(_ret === "continue")) {
                _context4.next = 23;
                break;
              }
              return _context4.abrupt("continue", 23);
            case 23:
              _context4.next = 18;
              break;
            case 25:
              _context4.next = 30;
              break;
            case 27:
              _context4.prev = 27;
              _context4.t1 = _context4["catch"](15);
              _iterator3.e(_context4.t1);
            case 30:
              _context4.prev = 30;
              _iterator3.f();
              return _context4.finish(30);
            case 33:
              if (!(updates.length > 0)) {
                _context4.next = 53;
                break;
              }
              this.isUpdatingCart = true;
              _iterator4 = _createForOfIteratorHelper(updates);
              _context4.prev = 36;
              _iterator4.s();
            case 38:
              if ((_step4 = _iterator4.n()).done) {
                _context4.next = 44;
                break;
              }
              update = _step4.value;
              _context4.next = 42;
              return fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(update)
              }).then(function (response) {
                return response.json();
              });
            case 42:
              _context4.next = 38;
              break;
            case 44:
              _context4.next = 49;
              break;
            case 46:
              _context4.prev = 46;
              _context4.t2 = _context4["catch"](36);
              _iterator4.e(_context4.t2);
            case 49:
              _context4.prev = 49;
              _iterator4.f();
              return _context4.finish(49);
            case 52:
              // Refresh cart after applying selling plans to new items
              setTimeout(function () {
                _this26.refreshCart();
              }, 100);
            case 53:
              _context4.next = 58;
              break;
            case 55:
              _context4.prev = 55;
              _context4.t3 = _context4["catch"](3);
              console.error("Error auto-applying frequency to new items:", _context4.t3);
            case 58:
              _context4.prev = 58;
              this.isUpdatingCart = false;
              return _context4.finish(58);
            case 61:
            case "end":
              return _context4.stop();
          }
        }, _callee2, this, [[3, 55, 58, 61], [15, 27, 30, 33], [36, 46, 49, 52]]);
      }));
      function autoApplyFrequencyToNewItems() {
        return _autoApplyFrequencyToNewItems.apply(this, arguments);
      }
      return autoApplyFrequencyToNewItems;
    }()
  }, {
    key: "initFromStoredFrequency",
    value: function initFromStoredFrequency() {
      // Check session storage for previously selected frequency
      var storedFrequency = sessionStorage.getItem("bmp-selected-frequency");
      var storedFrequencyText = sessionStorage.getItem("bmp-selected-frequency-text");
      if (storedFrequency && storedFrequencyText) {
        // Update the button display to show the stored selection
        this.updateSelectedDisplay(storedFrequency, storedFrequencyText);
      }
    }
  }, {
    key: "checkEmptyCart",
    value: function checkEmptyCart() {
      var _this27 = this;
      // Check if cart is empty and reset frequency selection if needed
      fetch("/cart.js").then(function (response) {
        return response.json();
      }).then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          // Cart is empty, clear stored frequency and reset button
          sessionStorage.removeItem("bmp-selected-frequency");
          sessionStorage.removeItem("bmp-selected-frequency-text");
          if (_this27.deliveryButton && _this27.btnTextCurrent) {
            _this27.btnTextCurrent.innerHTML = "Select Delivery Frequency";
            _this27.deliveryButton.classList.remove("checker-completed");
          }
        }
      })["catch"](function (error) {
        console.error("Error checking empty cart:", error);
      });
    }
  }, {
    key: "refreshCart",
    value: function refreshCart() {
      fetch("/cart.js").then(function (response) {
        if (!response.ok) throw new Error("HTTP error! status: ".concat(response.status));
        return response.json();
      }).then(function (cart) {
        // Enable checkout button if both postcode and frequency are selected
        var checkoutButtons = document.querySelectorAll('button[name="checkout"]');
        // Disabled auto-enabling checkout button based on session storage
        /*
        if (sessionStorage.getItem('bmp-postcode') && 
            sessionStorage.getItem('bmp-selected-frequency')) {
          checkoutButtons.forEach(button => {
            button.removeAttribute('disabled');
          });
        }
        */

        // Trigger cart update events
        document.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: cart
          }
        }));
        document.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            open: false
          }
        }));

        // Dispatch sellingPlan:cart:refresh for custom logic
        document.dispatchEvent(new CustomEvent("sellingPlan:cart:refresh", {
          bubbles: true,
          detail: {
            cart: cart
          }
        }));
        if (typeof FoxTheme !== "undefined" && FoxTheme.pubsub) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            cart: cart
          });
        }
      })["catch"](function (error) {
        console.error("Error refreshing cart:", error);
      });
    }
  }, {
    key: "checkCartForCheckoutEnable",
    value: function checkCartForCheckoutEnable() {
      // Check if cart total is more than $60 and delivery is passed by client
      fetch("/cart.js").then(function (response) {
        return response.json();
      }).then(function (cart) {
        var total = cart.total_price || 0;
        // $60 in cents = 6000
        var hasDelivery = !!sessionStorage.getItem("bmp-postcode");
        if (total >= FoxTheme.minimum_spend && hasDelivery) {
          // Enable all checkout buttons
          document.querySelectorAll('cart-drawer button[name="checkout"]').forEach(function (btn) {
            btn.removeAttribute("disabled");
          });
        } else {
          document.querySelectorAll('cart-drawer button[name="checkout"]').forEach(function (btn) {
            btn.setAttribute("disabled");
          });
        }
      })["catch"](function () {});
    }
  }]);
  return SellingPlanSelector;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element
if (!customElements.get("selling-plan-selector")) {
  customElements.define("selling-plan-selector", SellingPlanSelector);
}

// Utility function to handle cart drawer close
function setupDrawerCloseButtons() {
  document.querySelectorAll("cart-drawer .drawer__close-btn").forEach(function (closeButton) {
    closeButton.addEventListener("click", function (event) {
      event.preventDefault();
      var cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        cartDrawer.removeAttribute("active");
        cartDrawer.removeAttribute("open");
      }
    });
  });
}

// Initialize drawer close handlers
document.addEventListener("DOMContentLoaded", setupDrawerCloseButtons);

// Re-initialize drawer close handlers after cart updates
document.addEventListener("cart:updated", function () {
  setTimeout(setupDrawerCloseButtons, 1000); // Reduced delay for better performance
});

document.addEventListener("cart:refresh", function () {
  setTimeout(setupDrawerCloseButtons, 1000); // Reduced delay for better performance
});
var MobileTopBarIntersectionObserver = /*#__PURE__*/function () {
  function MobileTopBarIntersectionObserver() {
    _classCallCheck(this, MobileTopBarIntersectionObserver);
    this.topBarElement = document.getElementById("top-bar-facets");
    this.targetProductElement = document.querySelector('.product-column[data-index="3"]');
    this.spendTrackerElement = document.querySelector("spend-tracker");
    this.isMobile = window.innerWidth < 768; // Typical mobile breakpoint
    this.observer = null;
    if (this.topBarElement && this.targetProductElement && this.isMobile) {
      this.init();
    }

    // Re-initialize on resize to handle orientation changes
    window.addEventListener("resize", this.handleResize.bind(this));
  }
  _createClass(MobileTopBarIntersectionObserver, [{
    key: "init",
    value: function init() {
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
        root: null,
        // Use viewport as root
        rootMargin: "0px",
        threshold: [0, 0.5, 1] // Observe at different visibility thresholds
      });

      // Start observing the target product element
      this.observer.observe(this.targetProductElement);
    }
  }, {
    key: "handleIntersection",
    value: function handleIntersection(entries) {
      var _this28 = this;
      entries.forEach(function (entry) {
        if (entry.target === _this28.targetProductElement) {
          var topBarRect = _this28.topBarElement.getBoundingClientRect();
          var targetRect = entry.boundingClientRect;

          // Check if top bar has passed the target product
          var hasPassed = topBarRect.bottom > targetRect.top;
          if (hasPassed) {
            // Add class to spend tracker when topbar passes product index 3
            if (_this28.spendTrackerElement) {
              _this28.spendTrackerElement.classList.add("tracker-mobile-scrolled");
            }
            document.dispatchEvent(new CustomEvent("topbar:passedTarget", {
              bubbles: true,
              detail: {
                passed: true
              }
            }));
          } else {
            // Remove class when topbar is above product index 3
            if (_this28.spendTrackerElement) {
              _this28.spendTrackerElement.classList.remove("tracker-mobile-scrolled");
            }
            document.dispatchEvent(new CustomEvent("topbar:passedTarget", {
              bubbles: true,
              detail: {
                passed: false
              }
            }));
          }
        }
      });
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 768;

      // Disconnect existing observer if it exists
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      // If we're now on mobile and we weren't before, or if we're still on mobile
      if (this.isMobile && (this.isMobile !== wasMobile || wasMobile)) {
        if (this.topBarElement && this.targetProductElement) {
          this.init();
        }
      }

      // Clean up classes if we're no longer on mobile
      if (!this.isMobile) {
        if (this.spendTrackerElement) {
          this.spendTrackerElement.classList.remove("tracker-mobile-scrolled");
        }
      }
    }
  }]);
  return MobileTopBarIntersectionObserver;
}(); // Initialize the observer when DOM is loaded
document.addEventListener("DOMContentLoaded", function () {
  new MobileTopBarIntersectionObserver();

  // Example of how to listen for the custom event
  document.addEventListener("topbar:passedTarget", function (event) {
    console.log("Top bar passed target:", event.detail.passed);
    // You can add your custom functionality here
  });
});
var CartPostcodeChecker = /*#__PURE__*/function (_HTMLElement5) {
  _inherits(CartPostcodeChecker, _HTMLElement5);
  var _super5 = _createSuper(CartPostcodeChecker);
  function CartPostcodeChecker() {
    var _this29;
    _classCallCheck(this, CartPostcodeChecker);
    _this29 = _super5.call(this);
    _this29.postcodeInput = _this29.querySelector("input");
    _this29.alertElement = document.querySelector("cart-drawer #cartpage-postcode-alert");
    _this29.timeWindowsElement = _this29.querySelector(".time-windows");
    _this29.timeWindowLabels = _this29.querySelector(".time-window-labels");
    _this29.timeWindowsContainer = _this29.querySelector(".time-windows-container");
    _this29.timeWindowWrapper = _this29.querySelector(".time-window-wrapper") || _this29.createTimeWindowWrapper();
    _this29.checkerButton = _this29.querySelector('button[data-type="postcode-checker"]');
    _this29.closerButton = _this29.querySelector('button[data-type="postcode-closer"]');
    _this29.deliveryData = null;
    _this29.init();

    // Clear session storage to disable auto-initialization
    _this29.clearSessionStorage();

    // Listen for cart updates to maintain checkout button state
    _this29.setupCartUpdateListener();
    return _this29;
  }
  _createClass(CartPostcodeChecker, [{
    key: "createTimeWindowWrapper",
    value: function createTimeWindowWrapper() {
      // Create a time window wrapper if it doesn't exist
      var wrapper = document.createElement("div");
      wrapper.classList.add("time-window-wrapper");

      // Append it to the appropriate container
      if (this.timeWindowsContainer) {
        this.timeWindowsContainer.appendChild(wrapper);
      } else if (this.timeWindowsElement) {
        this.timeWindowsElement.appendChild(wrapper);
      } else {
        this.appendChild(wrapper);
      }
      return wrapper;
    }
  }, {
    key: "init",
    value: function init() {
      var _this30 = this;
      // Fetch the postcode data when component is initialized
      fetch("https://cdn.shopify.com/s/files/1/0621/2452/3737/files/postcode_delivery_areas_and_times_new.json?v=1747646811").then(function (response) {
        if (!response.ok) {
          throw new Error("Failed to load postcode data");
        }
        return response.json();
      }).then(function (data) {
        _this30.deliveryData = data;
        _this30.bindEvents();
      })["catch"](function (error) {
        console.error("Error loading postcode data:", error);
        _this30.showError("Unable to load delivery information. Please try again later.");
      });
    }
  }, {
    key: "setupCartUpdateListener",
    value: function setupCartUpdateListener() {
      // Listen for cart updates to maintain delivery state
      document.addEventListener("cart:updated", this.handleCartUpdate.bind(this));
      document.addEventListener("cart:refresh", this.handleCartUpdate.bind(this));
    }
  }, {
    key: "handleCartUpdate",
    value: function handleCartUpdate() {
      var _this31 = this;
      // Check if delivery information is still valid and re-enable checkout if needed
      var hasValidDelivery = this.checkDeliveryValidation();
      if (hasValidDelivery) {
        // Check cart total before re-enabling checkout
        fetch("/cart.js").then(function (response) {
          return response.json();
        }).then(function (cart) {
          var total = cart.total_price || 0;
          var meetsMinimumSpend = total >= (FoxTheme.minimum_spend || 6000); // Default to $60

          if (meetsMinimumSpend) {
            // Re-enable checkout button with a small delay to ensure cart UI is updated
            setTimeout(function () {
              _this31.enableCheckoutButton();
            }, 100);
          }
        })["catch"](function (error) {
          console.error("Error checking cart for minimum spend:", error);
        });
      }
    }
  }, {
    key: "checkDeliveryValidation",
    value: function checkDeliveryValidation() {
      // Check if all required delivery information is present in session storage
      var postcode = sessionStorage.getItem("bmp-postcode");
      var deliveryDate = sessionStorage.getItem("bmp-delivery-date");
      var selectedTimeWindow = sessionStorage.getItem("bmp-selected-time-window");
      var customerTimeWindowSelected = sessionStorage.getItem("bmp-customer-time-window-selected");
      return !!(postcode && deliveryDate && selectedTimeWindow && customerTimeWindowSelected);
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this32 = this;
      // Handle check postcode button click - only use the checker button
      if (this.checkerButton) {
        this.checkerButton.addEventListener("click", this.handleCheckPostcode.bind(this));
      }

      //Handle enter key on input field - but don't auto-trigger search
      this.postcodeInput.addEventListener("keyup", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          _this32.handleCheckPostcode();
        }
      });
      var debounceTimeout;
      this.postcodeInput.addEventListener("input", function () {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(function () {
          // Optionally, you could auto-validate here or just prepare for manual trigger
          _this32.handleCheckPostcode();
        }, 400);
      });

      // Handle closer button
      if (this.closerButton) {
        this.closerButton.addEventListener("click", function () {
          var modalComponent = _this32.closest("modal-component");
          if (modalComponent) {
            // Simulate overlay click animation
            var overlay = modalComponent.querySelector(".fixed-overlay");
            if (overlay) {
              overlay.classList.add("clicked");
            }
          }
        });
      }

      // Time window selections will be bound when they are created
    }
  }, {
    key: "handleCheckPostcode",
    value: function handleCheckPostcode() {
      var postcode = this.postcodeInput.value.trim();
      if (!postcode) {
        this.showError("Please enter a postcode");
        return;
      }

      // Clear session storage
      this.clearSessionStorage();

      // Save postcode to session storage
      sessionStorage.setItem("bmp-postcode", postcode);

      // Check if postcode exists in our data
      if (this.deliveryData && this.deliveryData.find(function (item) {
        return item.postcode.toString() === postcode;
      })) {
        var postcodeData = this.deliveryData.find(function (item) {
          return item.postcode.toString() === postcode;
        });
        this.handleValidPostcode(postcode, postcodeData);

        // Toggle button visibility on valid postcode
        if (this.checkerButton) this.checkerButton.classList.add("hidden");
        if (this.closerButton) this.closerButton.classList.remove("hidden");
      } else {
        this.handleInvalidPostcode(postcode);

        // Keep checker button visible, closer button hidden for invalid postcode
        if (this.checkerButton) this.checkerButton.classList.remove("hidden");
        if (this.closerButton) this.closerButton.classList.add("hidden");
      }
    }
  }, {
    key: "handleValidPostcode",
    value: function handleValidPostcode(postcode, postcodeData) {
      // Calculate next delivery date
      var deliveryDay = postcodeData.delivery_day;
      var deliveryDateArray = this.getNextDayOfTheWeek(deliveryDay);
      var deliveryDateString = deliveryDateArray[0];
      var deliveryDateFormatted = deliveryDateArray[1];
      var prodDateFormatted = deliveryDateArray[2];
      // Process time windows - parse the delivery_window string
      var timeWindows = this.parseTimeWindows(postcodeData.delivery_window);

      // #CD CODE... change date formate
      deliveryDateFormatted = deliveryDateString;

      // Save delivery info to session storage
      sessionStorage.setItem("bmp-delivery-date", deliveryDateFormatted);
      sessionStorage.setItem("bmp-production-date", prodDateFormatted);
      sessionStorage.setItem("bmp-delivery-day", deliveryDay);

      // Build success message
      this.showSuccessMessage(postcode, deliveryDay, deliveryDateString);

      // Show time windows
      this.showTimeWindows(timeWindows, deliveryDateString);

      // Enable checkout button
      this.enableCheckoutButton(deliveryDateString);


      // Update delivery date in UI if element exists
      var deliveryDateElement = document.querySelector("cart-drawer #cart-initial-delivery-date");
      if (deliveryDateElement) {
        deliveryDateElement.innerHTML = deliveryDateString;
      }

      // Update shipping text if element exists
      var shippingTextElement = document.querySelector("cart-drawer .shipping-text_1");
      if (shippingTextElement) {
        shippingTextElement.innerHTML = "Order now and get it on:";
      }

      // Call time windows function if it exists
      if (typeof Shopify !== "undefined" && Shopify.theme && Shopify.theme.ajaxCart) {
        var onlyGiftCards = false; // Default value, adjust as needed
        Shopify.theme.ajaxCart.getTimeWindows(onlyGiftCards);
      }
      var selllingPlanSelector = document.querySelector("cart-drawer selling-plan-selector");
      if (selllingPlanSelector) {
        document.dispatchEvent(new CustomEvent("sellingPlan:cart:refresh"));
      }
    }
  }, {
    key: "parseTimeWindows",
    value: function parseTimeWindows(deliveryWindowString) {
      var result = [];
      if (!deliveryWindowString) return result;

      // Split the delivery window string by "&" to get separate time windows
      var windows = deliveryWindowString.split("&");

      // Process each time window
      windows.forEach(function (window, index) {
        var parts = window.trim().split("-");
        if (parts.length >= 2) {
          var start = parts[0].trim();
          var end = parts[1].trim();
          result.push({
            start: start,
            end: end,
            id: "time-window-".concat(index),
            value: "".concat(start, "-").concat(end)
          });
        }
      });

      // If no windows defined, add default windows for testing
      if (result.length === 0) {
        result.push({
          start: "08:00",
          end: "18:00",
          id: "time-window-0",
          value: "08:00-18:00"
        });
        result.push({
          start: "00:00",
          end: "07:00",
          id: "time-window-1",
          value: "00:00-07:00"
        });
      }
      return result;
    }
  }, {
    key: "handleInvalidPostcode",
    value: function handleInvalidPostcode(postcode) {
      // Clear cart attributes and session storage
      this.clearCartAttributes();
      this.clearSessionStorage();

      // Show error message
      this.showError("Sorry, our delivery service is not yet available to the postcode area ".concat(postcode, "."));

      // Hide time windows
      this.hideTimeWindows();

      // Disable checkout button
      this.disableCheckoutButton();

      // Ensure check button is visible and close button is hidden
      if (this.checkerButton) this.checkerButton.classList.remove("hidden");
      if (this.closerButton) this.closerButton.classList.add("hidden");

      // Call time windows function if it exists
      if (typeof Shopify !== "undefined" && Shopify.theme && Shopify.theme.ajaxCart) {
        var onlyGiftCards = false; // Default value, adjust as needed
        Shopify.theme.ajaxCart.getTimeWindows(onlyGiftCards);
      }
      var postCodeButton = document.querySelector("cart-drawer .btn-cart-check-postcode");
      if (postCodeButton) {
        postCodeButton.classList.remove("checker-completed");
        var buttonText = postCodeButton.querySelector(".btn__text-current");
        if (buttonText) {
          buttonText.innerHTML = "Check Postcode";
        }
      }
    }
  }, {
    key: "showSuccessMessage",
    value: function showSuccessMessage(postcode, deliveryDay, deliveryDateString) {
    // CD code
    //  const extraDays = parseInt(this.alertElement.getAttribute("delivery_date"), 10) || 0;

    //   // TODAY (midnight)
    //   const today = new Date();
    //   today.setHours(0, 0, 0, 0);

    //   // ---------- LOCAL STORAGE CHECK ----------
    //   let saved = localStorage.getItem("delivery_date_saved");
    //   let deliveryDate;

    //   if (saved) {
    //     // If we already have a fixed delivery date, use that
    //     deliveryDate = new Date(saved);

    //     // If saved delivery date already passed → push next 7 days
    //     while (deliveryDate <= today) {
    //       deliveryDate.setDate(deliveryDate.getDate() + 7);
    //     }

    //   } else {
    //     // ---------- FIRST TIME CALCULATION ----------
    //     deliveryDate = new Date(today);
    //     deliveryDate.setDate(today.getDate() + 7 + extraDays);

    //     // Save FIRST TIME date permanently
    //     localStorage.setItem("delivery_date_saved", deliveryDate.toISOString());
    //   }

    //   // After adjusting new date, update localStorage
    //   localStorage.setItem("delivery_date_saved", deliveryDate.toISOString());

    //   // Ordinal function
    //   function getOrdinal(num) {
    //     if (num > 3 && num < 21) return num + "th";
    //     switch (num % 10) {
    //       case 1: return num + "st";
    //       case 2: return num + "nd";
    //       case 3: return num + "rd";
    //       default: return num + "th";
    //     }
    //   }

    //   // Format
    //   const weekday = deliveryDate.toLocaleDateString("en-US", { weekday: "long" });
    //   const day = getOrdinal(deliveryDate.getDate());
    //   const month = deliveryDate.toLocaleDateString("en-US", { month: "long" });

    //   const formattedDate = `${weekday} ${day} ${month}`;

      // Format success message
      var message = "<p>We deliver to postcode area ".concat(postcode, " on ").concat(deliveryDay, "s.</p>");
      // message += "<p>Your next available delivery date is ".concat(deliveryDateString, ".</p>");
      // message += `<p>Your next available delivery date is ${formattedDate}.</p>`;
      message += "<p>Please note if your delivery date falls on a public holiday, we will deliver the next business day.</p>";
      this.alertElement.removeAttribute("class");
      this.alertElement.classList.add("postcode-message", "success-message", "success");
      this.alertElement.innerHTML = message;
    }
  }, {
    key: "showError",
    value: function showError(message) {
      this.alertElement.removeAttribute("class");
      this.alertElement.classList.add("postcode-message", "error-message", "error");
      this.alertElement.innerHTML = message;
      this.hideTimeWindows();
    }
  }, {
    key: "showTimeWindows",
    value: function showTimeWindows(timeWindows, deliveryDateString) {
      var _this33 = this;
      console.log(timeWindows);
      //desorder time frames
      timeWindows = timeWindows.reverse();

      // Clear existing time windows in the wrapper
      if (this.timeWindowWrapper) {
        this.timeWindowWrapper.innerHTML = "";
      }

      // CD code
        // const extraDays = parseInt(this.alertElement.getAttribute("delivery_date"), 10) || 0;

        // // TODAY (midnight)
        // const today = new Date();
        // today.setHours(0, 0, 0, 0);

        // // ---------- LOCAL STORAGE CHECK ----------
        // let saved = localStorage.getItem("delivery_date_saved");
        // let deliveryDate;

        // // Function to get next Monday (fixed cycle)
        // function getNextMonday(fromDate) {
        //   const d = new Date(fromDate);
        //   const day = d.getDay(); // Monday = 1
        //   const diff = (1 - day + 7) % 7;
        //   const jump = diff === 0 ? 7 : diff; // If today is Monday → next Monday (7 days)
        //   d.setDate(d.getDate() + jump);
        //   return d;
        // }

        // if (saved) {
        //   // Already saved delivery date
        //   deliveryDate = new Date(saved);

        //   // If saved delivery date passed → Monday cycle (7 days)
        //   while (deliveryDate <= today) {
        //     deliveryDate.setDate(deliveryDate.getDate() + 7);
        //   }

        // } else {
        //   // ---------- FIRST TIME CALCULATION ----------
        //   // 1. Get next Monday
        //   deliveryDate = getNextMonday(today);

        //   // 2. Add extraDays (ts logic)
        //   if (extraDays > 0) {
        //     deliveryDate.setDate(deliveryDate.getDate() + extraDays);
        //   }

        //   // Save first time date
        //   localStorage.setItem("delivery_date_saved", deliveryDate.toISOString());
        // }

        // // Update localStorage after changes
        // localStorage.setItem("delivery_date_saved", deliveryDate.toISOString());

        // // Ordinal function
        // function getOrdinal(num) {
        //   if (num > 3 && num < 21) return num + "th";
        //   switch (num % 10) {
        //     case 1: return num + "st";
        //     case 2: return num + "nd";
        //     case 3: return num + "rd";
        //     default: return num + "th";
        //   }
        // }

        // // Format final date
        // const weekday = deliveryDate.toLocaleDateString("en-US", { weekday: "long" });
        // const day = getOrdinal(deliveryDate.getDate());
        // const month = deliveryDate.toLocaleDateString("en-US", { month: "long" });

        // const formattedDate = `${weekday} ${day} ${month}`;
      var ts_delivery_date = document.querySelector(".time-windows").getAttribute("delivery_date");
      var deliveryHeading = document.createElement("h4");
      deliveryHeading.classList.add("next-delivery-day-title");
      if(ts_delivery_date){
        deliveryHeading.innerHTML = `<strong>Next Delivery Day:</strong> ${ts_delivery_date}`;
      }else{
        deliveryHeading.innerHTML = `<strong>Next Delivery Day:</strong> ${deliveryDateString}`;
      }
      this.timeWindowWrapper.appendChild(deliveryHeading);
      // end cd code

      // Add a heading for time window selection
      var heading = document.createElement("h4");
      heading.textContent = "Select Prefered Delivery Time";
      this.timeWindowWrapper.appendChild(heading);

      // Show time window section
      if (this.timeWindowLabels) {
        this.timeWindowLabels.style.display = "block";
      }

      // Store time windows in session
      sessionStorage.setItem("bmp-time-windows", JSON.stringify(timeWindows));

      // Create checkbox for each time window
      timeWindows.forEach(function (window, index) {
        var timeWindowBox = document.createElement("div");
        timeWindowBox.classList.add("time-window-box");
        var checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.id = window.id;
        checkbox.name = "delivery-time-window";
        checkbox.value = window.value;
        checkbox.dataset.start = window.start;
        checkbox.dataset.end = window.end;

        // Check the first checkbox by default
        if (index === 0) {
          checkbox.checked = true;
          _this33.updateSelectedTimeWindow(window);
        }
        var label = document.createElement("label");
        label.htmlFor = window.id;

        // Add time window text in a span
        var timeSpan = document.createElement("span");
        timeSpan.textContent = "".concat(window.start, " - ").concat(window.end);

        // Add checkmark span
        var checkmark = document.createElement("span");
        checkmark.className = "checkmark";

        // Append both spans to the label
        label.appendChild(checkmark);
        label.appendChild(timeSpan);

        // Add event listener to each checkbox
        checkbox.addEventListener("change", function (e) {
          // Uncheck all other checkboxes
          document.querySelectorAll('cart-drawer input[name="delivery-time-window"]').forEach(function (cb) {
            if (cb !== e.target) cb.checked = false;
          });

          // Update selected time window
          if (e.target.checked) {
            _this33.updateSelectedTimeWindow(window);
          }
        });
        timeWindowBox.appendChild(checkbox);
        timeWindowBox.appendChild(label);

        // Append to the time-window-wrapper instead of timeWindowsContainer
        _this33.timeWindowWrapper.appendChild(timeWindowBox);
      });

      // Display the time-window-wrapper
      this.timeWindowWrapper.style.display = "flex";

      // Set default time window if none is checked
      setTimeout(function () {
        var anyChecked = document.querySelector('cart-drawer input[name="delivery-time-window"]:checked');
        if (!anyChecked && timeWindows.length > 0) {
          var firstCheckbox = document.querySelector('cart-drawer input[name="delivery-time-window"]');
          if (firstCheckbox) {
            firstCheckbox.checked = true;
            _this33.updateSelectedTimeWindow(timeWindows[0]);
          }
        }
      }, 100);
    }
  }, {
    key: "updateSelectedTimeWindow",
    value: function updateSelectedTimeWindow(window) {
      // Store selected time window in sessionStorage
      sessionStorage.setItem("bmp-selected-time-window", window.value);
      sessionStorage.setItem("bmp-customer-time-window-selected", "selected");

      // Update cart attributes with new time window
      this.updateCartAttributes({
        "Time Window Start": window.start,
        "Time Window End": window.end,
        "Postcode Entered": sessionStorage.getItem("bmp-postcode") || "",
        "Delivery Date": sessionStorage.getItem("bmp-delivery-date") || "",
        "Production Date": sessionStorage.getItem("bmp-production-date") || "",
        "Delivery Day": sessionStorage.getItem("bmp-delivery-day") || ""
      });

      console.log('ggggg', sessionStorage.getItem("bmp-delivery-date"))
    }
  }, {
    key: "hideTimeWindows",
    value: function hideTimeWindows() {
      if (this.timeWindowLabels) {
        this.timeWindowLabels.style.display = "none";
      }
      if (this.timeWindowWrapper) {
        this.timeWindowWrapper.style.display = "none";
        this.timeWindowWrapper.innerHTML = "";
      }
    }
  }, {
    key: "getNextDayOfTheWeek",
    value: function getNextDayOfTheWeek(dayName) {
      var excludeToday = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var refDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();
      // Helper for ordinal suffix
      function nth(d) {
        if (d > 3 && d < 21) return "th";
        switch (d % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
      }

      var day = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"].indexOf(dayName.slice(0, 3).toLowerCase());
      if (day < 0) return;
      var delDate;

      if (refDate.getDay() > 4) {
        delDate = new Date(refDate.setDate(refDate.getDate() + +!!excludeToday + (day + 14 - refDate.getDay() - +!!excludeToday)));
      } else {
        delDate = new Date(refDate.setDate(refDate.getDate() + +!!excludeToday + (day + 7 - refDate.getDay() - +!!excludeToday)));
      }
      
      var date = delDate.getDate();
      var month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][delDate.getMonth()];
      var repDate = "".concat(dayName, ", ").concat(date).concat(nth(date), " ").concat(month);
      var offset = delDate.getTimezoneOffset();
      var offsettedDate = new Date(delDate.getTime() - offset * 60 * 1000);
      
      var prodDate = new Date(offsettedDate);
      if (dayName === "Tuesday") {
        prodDate.setDate(prodDate.getDate() - 3);
      } else if (dayName === "Monday") {
        prodDate.setDate(prodDate.getDate() - 2);
      }
      var delDateFormatted = offsettedDate.toISOString().substring(0, 10).replaceAll("-", "/");
      var prodDateFormatted = prodDate.toISOString().substring(0, 10).replaceAll("-", "/");
      return [repDate, delDateFormatted, prodDateFormatted];
    }
  }, {
    key: "getOrdinalDate",
    value: function getOrdinalDate(date) {
      var day = date.getDate();
      var month = date.toLocaleString("default", {
        month: "long"
      });

      // Add ordinal suffix to day
      var dayWithSuffix = day;
      if (day > 3 && day < 21) dayWithSuffix += "th";else if (day % 10 === 1) dayWithSuffix += "st";else if (day % 10 === 2) dayWithSuffix += "nd";else if (day % 10 === 3) dayWithSuffix += "rd";else dayWithSuffix += "th";
      return "".concat(dayWithSuffix, " ").concat(month);
    }
  }, {
    key: "formatDateForCart",
    value: function formatDateForCart(date) {
      var day = String(date.getDate()).padStart(2, "0");
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var year = date.getFullYear();
      return "".concat(day, "/").concat(month, "/").concat(year);
    }
  }, {
    key: "updateCartAttributes",
    value: function updateCartAttributes(attributes) {
      if (typeof Shopify !== "undefined" && Shopify.theme && Shopify.theme.cart) {
        Shopify.theme.cart.updateAttributes(attributes);
      } else {
        // Fallback method if Shopify.theme.cart is not available
        console.log('calllll3333')
        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            attributes: attributes
          })
        })["catch"](function (error) {
          return console.error("Error updating cart attributes:", error);
        });
      }
    }
  }, {
    key: "clearCartAttributes",
    value: function clearCartAttributes() {
      if (typeof Shopify !== "undefined" && Shopify.theme && Shopify.theme.cart) {
        Shopify.theme.cart.clearAttributes();
      } else {
        // Fallback method
        this.updateCartAttributes({
          "Postcode Entered": "",
          "Time Window Start": "",
          "Time Window End": "",
          "Delivery Date": "",
          "Production Date": "",
          "Delivery Day": ""
        });
      }
    }
  }, {
    key: "clearSessionStorage",
    value: function clearSessionStorage() {
      if (typeof Shopify !== "undefined" && Shopify.theme && Shopify.theme.cart) {
        Shopify.theme.cart.clearSessionStorage();
      } else {
        // Fallback clear relevant session storage items
        var keys = ["bmp-postcode", "bmp-morning-time-window", "bmp-afternoon-time-window", "bmp-morning-time-window-start", "bmp-morning-time-window-end", "bmp-afternoon-time-window-start", "bmp-afternoon-time-window-end", "bmp-delivery-date", "bmp-production-date", "bmp-selected-time-window", "bmp-delivery-day", "bmp-customer-time-window-selected", "bmp-time-windows"];
        keys.forEach(function (key) {
          return sessionStorage.removeItem(key);
        });
      }
    }
  }, {
    key: "enableCheckoutButton",
    value: function enableCheckoutButton(deliveryDateString) {
    // CD code
    // const extraDays = parseInt(this.alertElement.getAttribute("delivery_date"), 10) || 0;

    // // TODAY (midnight)
    // const today = new Date();
    // today.setHours(0, 0, 0, 0);

    // // ---------- LOCAL STORAGE CHECK ----------
    // let saved = localStorage.getItem("delivery_date_saved");
    // let deliveryDate;

    // // Function to get next Monday (fixed cycle)
    // function getNextMonday(fromDate) {
    //   const d = new Date(fromDate);
    //   const day = d.getDay(); // Monday = 1
    //   const diff = (1 - day + 7) % 7;
    //   const jump = diff === 0 ? 7 : diff; // If today is Monday → next Monday (7 days)
    //   d.setDate(d.getDate() + jump);
    //   return d;
    // }

    // if (saved) {
    //   // Already saved delivery date
    //   deliveryDate = new Date(saved);

    //   // If saved delivery date passed → Monday cycle (7 days)
    //   while (deliveryDate <= today) {
    //     deliveryDate.setDate(deliveryDate.getDate() + 7);
    //   }

    // } else {
    //   // ---------- FIRST TIME CALCULATION ----------
    //   // 1. Get next Monday
    //   deliveryDate = getNextMonday(today);

    //   // 2. Add extraDays (ts logic)
    //   if (extraDays > 0) {
    //     deliveryDate.setDate(deliveryDate.getDate() + extraDays);
    //   }

    //   // Save first time date
    //   localStorage.setItem("delivery_date_saved", deliveryDate.toISOString());
    // }

    // // Update localStorage after changes
    // localStorage.setItem("delivery_date_saved", deliveryDate.toISOString());

    // // Ordinal function
    // function getOrdinal(num) {
    //   if (num > 3 && num < 21) return num + "th";
    //   switch (num % 10) {
    //     case 1: return num + "st";
    //     case 2: return num + "nd";
    //     case 3: return num + "rd";
    //     default: return num + "th";
    //   }
    // }

    // // Format final date
    // const weekday = deliveryDate.toLocaleDateString("en-US", { weekday: "long" });
    // const day = getOrdinal(deliveryDate.getDate());
    // const month = deliveryDate.toLocaleDateString("en-US", { month: "long" });

    // const formattedDate = `${weekday} ${day} ${month}`;

      // Enable the delivery frequency button if it exists
      var deliveryFrequencyButton = document.querySelector("cart-drawer .btn-cart-check-delevery");
      if (deliveryFrequencyButton) {
        deliveryFrequencyButton.removeAttribute("disabled");
      }
      var ts_delivery_date_slip = document.querySelector(".time-windows").getAttribute("delivery_date");
      if(ts_delivery_date_slip){
       var slip_date_show = ts_delivery_date_slip
      }else{
        var slip_date_show = deliveryDateString
      }
      // CD code 
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            delivery_date: slip_date_show 
          }
        })
      })
      .then(res => res.json())
      .then(data => {
        console.log("Cart updated:", data);
      })
      .catch(err => console.error(err));

      var postCodeButton = document.querySelector("cart-drawer .btn-cart-check-postcode");
      if (postCodeButton) {
        postCodeButton.classList.add("checker-completed");
        var buttonText = postCodeButton.querySelector(".btn__text-current");
        if (buttonText) {
           var ts_delivery_date = document.querySelector(".time-windows").getAttribute("delivery_date");
           const savedText = sessionStorage.getItem("bmp-postcode") || "";
           if(ts_delivery_date){
             buttonText.innerHTML = `${savedText} - ${ts_delivery_date}`;
           }else{
             buttonText.innerHTML = `${savedText} - ${deliveryDateString}`;
           }

            var current_input = document.querySelector('cart-postcode-checker input').value.trim();
            if (this.deliveryData && this.deliveryData.find(function (item) {
              return item.postcode.toString() === current_input;
            })){
              var newpostcodeData = this.deliveryData.find(function (item) {
                return item.postcode.toString() === current_input;
              });
              const savedText = sessionStorage.getItem("bmp-postcode") || "";
              var newdeliveryDay = newpostcodeData.delivery_day;
              var newdeliveryDateArray = this.getNextDayOfTheWeek(newdeliveryDay);
              var newdeliveryDateString = newdeliveryDateArray[0];
              var ts_delivery_date = document.querySelector(".time-windows").getAttribute("delivery_date");
                if(ts_delivery_date){
                  buttonText.innerHTML = `${savedText} - ${ts_delivery_date}`;
                }else{
                  buttonText.innerHTML = `${savedText} - ${newdeliveryDateString}`;
                }
              }


          //  buttonText.innerHTML = "".concat(sessionStorage.getItem("bmp-postcode") || "");  
        }
      }

      

      // Disabled auto-enabling checkout buttons
      /*
      const checkoutButtons = document.querySelectorAll('button[name="checkout"]');
      checkoutButtons.forEach(button => {
        button.removeAttribute('disabled');
      });
      */
    }
  }, {
    key: "disableCheckoutButton",
    value: function disableCheckoutButton() {
      // Disable the delivery frequency button if it exists
      var deliveryFrequencyButton = document.querySelector("cart-drawer .btn-cart-check-delevery");
      if (deliveryFrequencyButton) {
        deliveryFrequencyButton.setAttribute("disabled", "disabled");
      }

      // Disable checkout buttons
      var checkoutButtons = document.querySelectorAll('button[name="checkout"]');
      checkoutButtons.forEach(function (button) {
        button.setAttribute("disabled", "disabled");
      });
    }
  }]);
  return CartPostcodeChecker;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element if it's not already defined
if (!customElements.get("cart-postcode-checker")) {
  customElements.define("cart-postcode-checker", CartPostcodeChecker);
}
var CustomPostcodeChecker = /*#__PURE__*/function (_HTMLElement6) {
  _inherits(CustomPostcodeChecker, _HTMLElement6);
  var _super6 = _createSuper(CustomPostcodeChecker);
  function CustomPostcodeChecker() {
    var _this34;
    _classCallCheck(this, CustomPostcodeChecker);
    _this34 = _super6.call(this);
    _this34.postcodeInput = _this34.querySelector("input");
    _this34.alertElement = document.querySelector(".delivery-checker #cartpage-postcode-alert");
    _this34.timeWindowsElement = _this34.querySelector(".delivery-checker .time-windows");
    _this34.timeWindowLabels = _this34.querySelector(".delivery-checker .time-window-labels");
    _this34.timeWindowsContainer = _this34.querySelector(".delivery-checker .time-windows-container");
    _this34.timeWindowWrapper = _this34.querySelector(".delivery-checker .time-window-wrapper") || _this34.createTimeWindowWrapper();
    _this34.checkerButton = _this34.querySelector('.delivery-checker button[data-type="postcode-checker"]');
    _this34.closerButton = _this34.querySelector('.delivery-checker button[data-type="postcode-closer"]');
    _this34.deliveryData = null;
    _this34.init();
    return _this34;
  }
  _createClass(CustomPostcodeChecker, [{
    key: "createTimeWindowWrapper",
    value: function createTimeWindowWrapper() {
      // Create a time window wrapper if it doesn't exist
      var wrapper = document.createElement("div");
      wrapper.classList.add("time-window-wrapper");

      // Append it to the appropriate container
      if (this.timeWindowsContainer) {
        this.timeWindowsContainer.appendChild(wrapper);
      } else if (this.timeWindowsElement) {
        this.timeWindowsElement.appendChild(wrapper);
      } else {
        this.appendChild(wrapper);
      }
      return wrapper;
    }
  }, {
    key: "init",
    value: function init() {
      var _this35 = this;
      // Fetch the postcode data when component is initialized
      fetch("https://cdn.shopify.com/s/files/1/0621/2452/3737/files/postcode_delivery_areas_and_times_new.json?v=1747646811").then(function (response) {
        if (!response.ok) {
          throw new Error("Failed to load postcode data");
        }
        return response.json();
      }).then(function (data) {
        _this35.deliveryData = data;
        _this35.bindEvents();
      })["catch"](function (error) {
        _this35.showError("Unable to load delivery information. Please try again later.");
      });
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      // Handle check postcode button click - only use the checker button
      if (this.checkerButton) {
        this.checkerButton.addEventListener("click", this.handleCheckPostcode.bind(this));
      }

      // Handle enter key on input field - but don't auto-trigger search
      // this.postcodeInput.addEventListener('keyup', (event) => {
      //   if (event.key === 'Enter') {
      //     event.preventDefault();
      //     this.handleCheckPostcode();
      //   }
      // });

      // Time window selections will be bound when they are created
    }
  }, {
    key: "handleCheckPostcode",
    value: function handleCheckPostcode() {
      var postcode = this.postcodeInput.value.trim();
      if (!postcode) {
        this.showError("Please enter a postcode");
        return;
      }
      // Check if postcode exists in our data
      if (this.deliveryData && this.deliveryData.find(function (item) {
        return item.postcode.toString() === postcode;
      })) {
        var postcodeData = this.deliveryData.find(function (item) {
          return item.postcode.toString() === postcode;
        });
        this.handleValidPostcode(postcode, postcodeData);
      } else {
        this.handleInvalidPostcode(postcode);
      }
    }
  }, {
    key: "handleValidPostcode",
    value: function handleValidPostcode(postcode, postcodeData) {
      // Calculate next delivery date
      var deliveryDay = postcodeData.delivery_day;
      var deliveryDateArray = this.getNextDayOfTheWeek(deliveryDay);
      var deliveryDateString = deliveryDateArray[0];
      var deliveryDateFormatted = deliveryDateArray[1];
      var prodDateFormatted = deliveryDateArray[2];

      // Process time windows - parse the delivery_window string
      var timeWindows = this.parseTimeWindows(postcodeData.delivery_window);

      // Build success message
      this.showSuccessMessage(postcode, deliveryDay, deliveryDateString);

      // Show time windows
      this.showTimeWindows(timeWindows);

      this.enableCheckoutButton(timeWindows);

      // Update delivery date in UI if element exists
      var deliveryDateElement = document.querySelector(".delivery-checker #cart-initial-delivery-date");
      if (deliveryDateElement) {
        deliveryDateElement.innerHTML = deliveryDateString;
      }

      // Update shipping text if element exists
      var shippingTextElement = document.querySelector(".delivery-checker .shipping-text_1");
      if (shippingTextElement) {
        shippingTextElement.innerHTML = "Order now and get it on:";
      }
    }
  }, {
    key: "parseTimeWindows",
    value: function parseTimeWindows(deliveryWindowString) {
      var result = [];
      if (!deliveryWindowString) return result;

      // Split the delivery window string by "&" to get separate time windows
      var windows = deliveryWindowString.split("&");

      // Process each time window
      windows.forEach(function (window, index) {
        var parts = window.trim().split("-");
        if (parts.length >= 2) {
          var start = parts[0].trim();
          var end = parts[1].trim();
          result.push({
            start: start,
            end: end,
            id: "time-window-".concat(index),
            value: "".concat(start, "-").concat(end)
          });
        }
      });

      // If no windows defined, add default windows for testing
      if (result.length === 0) {
        result.push({
          start: "08:00",
          end: "18:00",
          id: "ctime-window-0",
          value: "08:00-18:00"
        });
        result.push({
          start: "00:00",
          end: "07:00",
          id: "ctime-window-1",
          value: "00:00-07:00"
        });
      }
      return result;
    }
  }, {
    key: "handleInvalidPostcode",
    value: function handleInvalidPostcode(postcode) {
      // Show error message
      this.showError("Sorry, our delivery service is not yet available to the postcode area ".concat(postcode, "."));

      // Hide time windows
      this.hideTimeWindows();
    }
  }, {
    key: "showSuccessMessage",
    value: function showSuccessMessage(postcode, deliveryDay, deliveryDateString) {
      var ts_delivery_date = document.querySelector(".time-windows").getAttribute("delivery_date");
      // Format success message
      var message = "<p>We deliver to postcode area ".concat(postcode, " on ").concat(deliveryDay, "s.</p>");
      if(ts_delivery_date){
        message += "<p>Your next available delivery date is ".concat(ts_delivery_date, ".</p>");
      }else{
        message += "<p>Your next available delivery date is ".concat(deliveryDateString, ".</p>");
      }
      message += "<p>Please note if your delivery date falls on a public holiday, we will deliver the next business day.</p>";
      this.alertElement.removeAttribute("class");
      this.alertElement.classList.add("postcode-message", "success-message", "success");
      this.alertElement.innerHTML = message;
    }
  }, {
    key: "showError",
    value: function showError(message) {
      this.alertElement.removeAttribute("class");
      this.alertElement.classList.add("postcode-message", "error-message", "error");
      this.alertElement.innerHTML = message;
      this.hideTimeWindows();
    }
  }, {
    key: "showTimeWindows",
    value: function showTimeWindows(timeWindows) {
      var _this36 = this;
      // Clear existing time windows in the wrapper
      if (this.timeWindowWrapper) {
        this.timeWindowWrapper.innerHTML = "";
      }

      // Add a heading for time window selection
      var heading = document.createElement("h4");
      heading.textContent = "Delivery Time";
      this.timeWindowWrapper.appendChild(heading);

      // Show time window section
      if (this.timeWindowLabels) {
        this.timeWindowLabels.style.display = "block";
      }

      // Create checkbox for each time window
      timeWindows.forEach(function (window, index) {
        var timeWindowBox = document.createElement("div");
        timeWindowBox.classList.add("time-window-box");
        var checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.id = "c" + window.id;
        checkbox.name = "delivery-time-window";
        checkbox.value = window.value;
        checkbox.dataset.start = window.start;
        checkbox.dataset.end = window.end;

        // Check the first checkbox by default
        if (index === 0) {
          checkbox.checked = true;
        }
        var label = document.createElement("label");
        label.htmlFor = "c" + window.id;

        // Add time window text in a span
        var timeSpan = document.createElement("span");
        timeSpan.textContent = "".concat(window.start, " - ").concat(window.end);

        // Add checkmark span
        var checkmark = document.createElement("span");
        checkmark.className = "checkmark";

        // Append both spans to the label
        label.appendChild(checkmark);
        label.appendChild(timeSpan);

        // Add event listener to each checkbox
        checkbox.addEventListener("change", function (e) {
          // Uncheck all other checkboxes
          document.querySelectorAll('.delivery-checker input[name="delivery-time-window"]').forEach(function (cb) {
            if (cb !== e.target) cb.checked = false;
          });

          // Update selected time window
          if (e.target.checked) {}
        });
        timeWindowBox.appendChild(checkbox);
        timeWindowBox.appendChild(label);

        // Append to the time-window-wrapper instead of timeWindowsContainer
        _this36.timeWindowWrapper.appendChild(timeWindowBox);
      });

      // Display the time-window-wrapper
      this.timeWindowWrapper.style.display = "flex";

      // Set default time window if none is checked
      setTimeout(function () {
        var anyChecked = document.querySelector('.delivery-checker input[name="delivery-time-window"]:checked');
        if (!anyChecked && timeWindows.length > 0) {
          var firstCheckbox = document.querySelector('.delivery-checker input[name="delivery-time-window"]');
          if (firstCheckbox) {
            firstCheckbox.checked = true;
          }
        }
      }, 100);
    }
  }, {
    key: "hideTimeWindows",
    value: function hideTimeWindows() {
      if (this.timeWindowLabels) {
        this.timeWindowLabels.style.display = "none";
      }
      if (this.timeWindowWrapper) {
        this.timeWindowWrapper.style.display = "none";
        this.timeWindowWrapper.innerHTML = "";
      }
    }
  }, {
    key: "getNextDayOfTheWeek",
    value: function getNextDayOfTheWeek(dayName) {
      var excludeToday = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var refDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();
      // Helper for ordinal suffix
      function nth(d) {
        if (d > 3 && d < 21) return "th";
        switch (d % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
      }
      var day = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"].indexOf(dayName.slice(0, 3).toLowerCase());
      if (day < 0) return;
      var delDate;
      if (refDate.getDay() > 4) {
        delDate = new Date(refDate.setDate(refDate.getDate() + +!!excludeToday + (day + 14 - refDate.getDay() - +!!excludeToday)));
      } else {
        delDate = new Date(refDate.setDate(refDate.getDate() + +!!excludeToday + (day + 7 - refDate.getDay() - +!!excludeToday)));
      }
      var date = delDate.getDate();
      var month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][delDate.getMonth()];
      var repDate = "".concat(dayName, ", ").concat(date).concat(nth(date), " ").concat(month);
      var offset = delDate.getTimezoneOffset();
      var offsettedDate = new Date(delDate.getTime() - offset * 60 * 1000);
      var prodDate = new Date(offsettedDate);
      if (dayName === "Tuesday") {
        prodDate.setDate(prodDate.getDate() - 3);
      } else if (dayName === "Monday") {
        prodDate.setDate(prodDate.getDate() - 2);
      }
      var delDateFormatted = offsettedDate.toISOString().substring(0, 10).replaceAll("-", "/");
      var prodDateFormatted = prodDate.toISOString().substring(0, 10).replaceAll("-", "/");
      return [repDate, delDateFormatted, prodDateFormatted];
    }
  }, {
    key: "getOrdinalDate",
    value: function getOrdinalDate(date) {
      var day = date.getDate();
      var month = date.toLocaleString("default", {
        month: "long"
      });

      // Add ordinal suffix to day
      var dayWithSuffix = day;
      if (day > 3 && day < 21) dayWithSuffix += "th";else if (day % 10 === 1) dayWithSuffix += "st";else if (day % 10 === 2) dayWithSuffix += "nd";else if (day % 10 === 3) dayWithSuffix += "rd";else dayWithSuffix += "th";
      return "".concat(dayWithSuffix, " ").concat(month);
    }
  }, {
    key: "formatDateForCart",
    value: function formatDateForCart(date) {
      var day = String(date.getDate()).padStart(2, "0");
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var year = date.getFullYear();
      return "".concat(day, "/").concat(month, "/").concat(year);
    }
  }]);
  return CustomPostcodeChecker;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element if it's not already defined
if (!customElements.get("custom-postcode-checker")) {
  customElements.define("custom-postcode-checker", CustomPostcodeChecker);
}

// document.addEventListener("cart:boxs:updated", (event) => {
//   console.log("dd");
//   // Fetch cart content and update attributes via JS API
//   fetch("/cart.js")
//     .then((response) => response.json())
//     .then((cart) => {
//       // Session storage updater for box count
//       let boxCountAggregate = { large: 0, small: 0 };
//       let size, count, qty;
//       const countArray = event.detail.countArray || [];
//       if (cart && cart.items && countArray.length === cart.items.length) {
//         for (let i = 0; i < cart.items.length; i++) {
//           size = countArray[i].size;
//           count = Number(countArray[i].count);
//           qty = Number(cart.items[i].quantity);
//           if (size === "large") {
//             boxCountAggregate.large += qty * count;
//           } else if (size === "small") {
//             boxCountAggregate.small += qty * count;
//           }
//         }
//         // Store in sessionStorage
//         sessionStorage.setItem("box-count-large", boxCountAggregate.large);
//         sessionStorage.setItem("box-count-small", boxCountAggregate.small);
//         sessionStorage.setItem(
//           "box-count-aggregate",
//           boxCountAggregate.large + boxCountAggregate.small
//         );

//         // Call boxCounter if defined
//         if (typeof window.boxCounter === "function") {
//           window.boxCounter();
//         }
//       }
//     })
//     .catch((err) => console.error("Failed to fetch cart:", err));
// });

if (typeof FoxTheme !== "undefined" && FoxTheme.pubsub) {
  FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
    setTimeout(function () {
      var countArray = [];
      var boxCountAggregate = {
        large: 0,
        small: 0
      };
      var cartItems = document.querySelectorAll("cart-items .cart-item");
      cartItems.forEach(function (item) {
        var size = item.getAttribute("data-product-size").trim();
        var count = Number(item.getAttribute("data-product-count").trim());
        var qty = Number(item.getAttribute("data-product-qte").trim());
        countArray.push({
          size: size,
          count: count
        });
        // The rest of this script can be deleted - it's just to initialise the boxCountAggregate object
        if (size == "large") {
          boxCountAggregate.large = boxCountAggregate.large + count * qty;
          // console.log("large " + boxCountAggregate.large)
        } else if (size == "small") {
          boxCountAggregate.small = boxCountAggregate.small + count * qty;
          // console.log("large " + boxCountAggregate.small)
        }
      });

      var large = boxCountAggregate.large;
      var small = boxCountAggregate.small;
      var boxCount = Math.ceil((6 * large + small) / 155) || 1;
      sessionStorage.setItem("box-count-large", large);
      sessionStorage.setItem("box-count-small", small);
      sessionStorage.setItem("box-count-aggregate", boxCount);
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          attributes: {
            "Large items": sessionStorage.getItem("box-count-large"),
            "Small items": sessionStorage.getItem("box-count-small"),
            "Total boxes": sessionStorage.getItem("box-count-aggregate")
          }
        })
      })["catch"](function (err) {
        return console.error("Failed to update cart attributes:", err);
      });
    }, 1000);
  });
}
document.addEventListener("DOMContentLoaded", function () {
  // Your code to execute on content load goes here
  setTimeout(function () {
    var countArray = [];
    var boxCountAggregate = {
      large: 0,
      small: 0
    };
    var cartItems = document.querySelectorAll("cart-items .cart-item");
    cartItems.forEach(function (item) {
      var size = item.getAttribute("data-product-size").trim();
      var count = Number(item.getAttribute("data-product-count").trim());
      var qty = Number(item.getAttribute("data-product-qte").trim());
      countArray.push({
        size: size,
        count: count
      });
      // The rest of this script can be deleted - it's just to initialise the boxCountAggregate object
      if (size == "large") {
        boxCountAggregate.large = boxCountAggregate.large + count * qty;
        // console.log("large " + boxCountAggregate.large)
      } else if (size == "small") {
        boxCountAggregate.small = boxCountAggregate.small + count * qty;
        // console.log("large " + boxCountAggregate.small)
      }
    });

    var large = boxCountAggregate.large;
    var small = boxCountAggregate.small;
    var boxCount = Math.ceil((6 * large + small) / 155) || 1;
    sessionStorage.setItem("box-count-large", large);
    sessionStorage.setItem("box-count-small", small);
    sessionStorage.setItem("box-count-aggregate", boxCount);
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        attributes: {
          "Large items": sessionStorage.getItem("box-count-large"),
          "Small items": sessionStorage.getItem("box-count-small"),
          "Total boxes": sessionStorage.getItem("box-count-aggregate")
        }
      })
    })["catch"](function (err) {
      return console.error("Failed to update cart attributes:", err);
    });

    // Intercept checkout button to force selling plan update before checkout
    var cartDrawer = document.getElementById("CartDrawer");
    if (cartDrawer) {
      var checkoutForm = cartDrawer.querySelector('form.drawer__footer-buttons');
      var checkoutButton = checkoutForm === null || checkoutForm === void 0 ? void 0 : checkoutForm.querySelector('button[type="submit"][name="checkout"]');
      var sellingPlanSelector = cartDrawer.querySelector("selling-plan-selector");
      if (checkoutButton && checkoutForm && sellingPlanSelector) {
        checkoutButton.addEventListener("click", function (event) {
          // Prevent default form submission
          event.preventDefault();

          // If SellingPlanSelector is defined and has updateCartSellingPlan
          var selectorInstance = sellingPlanSelector;
          if (selectorInstance && typeof selectorInstance.updateCartSellingPlan === "function") {
            // Get selected frequency from sessionStorage or UI
            var frequency = sessionStorage.getItem("bmp-selected-frequency") || "onetime";
            // Call updateCartSellingPlan, then submit form
            var maybePromise = selectorInstance.updateCartSellingPlan(frequency);

            // Show spinner on checkout button (like add to cart)
            var spinner = checkoutButton.querySelector('.checkout-spinner');
            if (!spinner) {
              spinner = document.createElement('span');
              spinner.className = 'checkout-spinner';
              spinner.style.display = 'inline-block';
              spinner.style.verticalAlign = 'middle';
              spinner.style.marginLeft = '8px';
              spinner.innerHTML = '<svg width="22" height="22" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="22" cy="22" r="20" stroke="#3498db" stroke-width="4" stroke-linecap="round" stroke-dasharray="31 80" stroke-dashoffset="0"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.8s" from="0 22 22" to="360 22 22"/></circle></svg>';
              checkoutButton.appendChild(spinner);
            } else {
              spinner.style.display = 'inline-block';
            }
            checkoutButton.setAttribute('aria-busy', 'true');
            checkoutButton.disabled = true;
            if (maybePromise && typeof maybePromise.then === "function") {
              maybePromise.then(function () {
                spinner.style.display = 'none';
                checkoutButton.removeAttribute('aria-busy');
                window.location.href = '/checkout';
              })["catch"](function () {
                spinner.style.display = 'none';
                checkoutButton.removeAttribute('aria-busy');
                // On error, still submit to avoid blocking checkout
                window.location.href = '/checkout';
              });
            } else {
              // If not a promise, just submit
              spinner.style.display = 'none';
              checkoutButton.removeAttribute('aria-busy');
              window.location.href = '/checkout';
            }
          } else {
            // If no selling plan selector, just submit
            window.location.href = '/checkout';
          }
        });
      }
    }
  }, 500);
});
var CaloriesCalculator = /*#__PURE__*/function (_HTMLElement7) {
  _inherits(CaloriesCalculator, _HTMLElement7);
  var _super7 = _createSuper(CaloriesCalculator);
  function CaloriesCalculator() {
    var _this37;
    _classCallCheck(this, CaloriesCalculator);
    _this37 = _super7.call(this);
    _this37.isShowingResults = false;
    return _this37;
  }
  _createClass(CaloriesCalculator, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      // Ensure results are hidden initially
      var resultsDiv = this.querySelector("#results");
      if (resultsDiv) {
        resultsDiv.style.display = "none";
      }
      this.bindEvents();
      // Run initial validation to set correct button state
      this.validateForm();
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this38 = this;
      var form = this.querySelector("#calories-form");
      if (form) {
        form.addEventListener("submit", this.calculateCalories.bind(this));
      }

      // Validate form and enable/disable button on input change
      var inputs = this.querySelectorAll("input, select");
      inputs.forEach(function (input) {
        input.addEventListener("change", _this38.validateForm.bind(_this38));
        input.addEventListener("input", _this38.validateForm.bind(_this38));
      });
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var _this$querySelector, _this$querySelector2, _this$querySelector3, _this$querySelector4, _this$querySelector5, _this$querySelector6;
      // Don't validate if showing results
      if (this.isShowingResults) return;

      // Check if all required fields are filled
      var age = parseInt(((_this$querySelector = this.querySelector("#age")) === null || _this$querySelector === void 0 ? void 0 : _this$querySelector.value) || 0);
      var gender = ((_this$querySelector2 = this.querySelector("#gender")) === null || _this$querySelector2 === void 0 ? void 0 : _this$querySelector2.value) || "";
      var weight = parseFloat(((_this$querySelector3 = this.querySelector("#weight")) === null || _this$querySelector3 === void 0 ? void 0 : _this$querySelector3.value) || 0);
      var height = parseFloat(((_this$querySelector4 = this.querySelector("#height")) === null || _this$querySelector4 === void 0 ? void 0 : _this$querySelector4.value) || 0);
      var activityLevel = ((_this$querySelector5 = this.querySelector("#activity-level")) === null || _this$querySelector5 === void 0 ? void 0 : _this$querySelector5.value) || "";
      var goal = ((_this$querySelector6 = this.querySelector("#goal")) === null || _this$querySelector6 === void 0 ? void 0 : _this$querySelector6.value) || "";
      var submitButton = this.querySelector('button[type="submit"]');
      var allFieldsFilled = age && gender && weight && height && activityLevel && goal;
      if (submitButton) {
        submitButton.disabled = !allFieldsFilled;
      }
      this.hideError();
    }
  }, {
    key: "calculateCalories",
    value: function calculateCalories(event) {
      event.preventDefault();
      var age = parseInt(this.querySelector("#age").value);
      var gender = this.querySelector("#gender").value;
      var weight = parseFloat(this.querySelector("#weight").value);
      var height = parseFloat(this.querySelector("#height").value);
      var activityLevel = this.querySelector("#activity-level").value;
      var goal = this.querySelector("#goal").value;
      if (!age || !gender || !weight || !height || !activityLevel || !goal) {
        this.showError("Please fill in all fields");
        return;
      }
      this.performCalculation(age, gender, weight, height, activityLevel, goal);
    }
  }, {
    key: "performCalculation",
    value: function performCalculation(age, gender, weight, height, activityLevel, goal) {
      // Calculate BMR using Mifflin-St Jeor Equation
      var bmr;
      if (gender === "male") {
        bmr = 10 * weight + 6.25 * height - 5 * age + 5;
      } else {
        bmr = 10 * weight + 6.25 * height - 5 * age - 161;
      }

      // Activity level multipliers
      var activityMultipliers = {
        sedentary: 1.2,
        "lightly-active": 1.375,
        "moderately-active": 1.55,
        "very-active": 1.725,
        athlete: 1.9
      };

      // Calculate TDEE (Total Daily Energy Expenditure)
      var tdee = bmr * activityMultipliers[activityLevel];

      // Adjust calories based on goal
      var targetCalories;
      switch (goal) {
        case "fat-loss":
          targetCalories = tdee - 500; // 500 calorie deficit
          break;
        case "maintenance":
          targetCalories = tdee;
          break;
        case "muscle-gain":
          targetCalories = tdee + 300; // 300 calorie surplus
          break;
        default:
          targetCalories = tdee;
      } // Calculate macros based on goal and weight
      var macros = this.calculateMacros(targetCalories, goal, weight);
      this.displayResults(targetCalories, macros);
    }
  }, {
    key: "calculateMacros",
    value: function calculateMacros(calories, goal, weight) {
      // Weight-based protein calculations (grams per kg of body weight)
      var proteinGramsPerKg;
      switch (goal) {
        case "fat-loss":
          proteinGramsPerKg = 2.2;
          break;
        case "maintenance":
          proteinGramsPerKg = 1.8;
          break;
        case "muscle-gain":
          proteinGramsPerKg = 2.2;
          break;
        default:
          proteinGramsPerKg = 1.8;
      }

      // Calculate protein grams and calories
      var proteinGrams = Math.round(weight * proteinGramsPerKg);
      var proteinCalories = proteinGrams * 4;

      // Calculate remaining calories after protein
      var remainingCalories = calories - proteinCalories;

      // Set carb and fat percentages for remaining calories
      var carbRatio, fatRatio;
      switch (goal) {
        case "fat-loss":
          carbRatio = 0.4;
          fatRatio = 0.3;
          break;
        case "maintenance":
          carbRatio = 0.45;
          fatRatio = 0.3;
          break;
        case "muscle-gain":
          carbRatio = 0.5;
          fatRatio = 0.3;
          break;
        default:
          carbRatio = 0.45;
          fatRatio = 0.3;
      }

      // Calculate carb and fat calories from remaining calories
      var carbCalories = Math.round(remainingCalories * carbRatio);
      var fatCalories = Math.round(remainingCalories * fatRatio);

      // Calculate grams
      var carbGrams = Math.round(carbCalories / 4);
      var fatGrams = Math.round(fatCalories / 9);

      // Calculate percentages of total calories for display
      var proteinPercentage = Math.round(proteinCalories / calories * 100);
      var carbPercentage = Math.round(carbCalories / calories * 100);
      var fatPercentage = Math.round(fatCalories / calories * 100);
      return {
        protein: {
          grams: proteinGrams,
          calories: proteinCalories,
          percentage: proteinPercentage
        },
        carbs: {
          grams: carbGrams,
          calories: carbCalories,
          percentage: carbPercentage
        },
        fat: {
          grams: fatGrams,
          calories: fatCalories,
          percentage: fatPercentage
        }
      };
    }
  }, {
    key: "displayResults",
    value: function displayResults(calories, macros) {
      var form = this.querySelector("#calculator-container");
      var resultsDiv = this.querySelector("#results");
      if (!form || !resultsDiv) return;

      // Hide the form and show results
      this.isShowingResults = true;
      form.style.display = "none";

      // Update the calorie and macro values in the results display
      var caloriesValue = resultsDiv.querySelector(".calories-value");
      var proteinValue = resultsDiv.querySelector(".protein-value");
      var carbsValue = resultsDiv.querySelector(".carbs-value");
      var fatValue = resultsDiv.querySelector(".fat-value");
      if (caloriesValue) caloriesValue.textContent = Math.round(calories);
      if (proteinValue) proteinValue.textContent = "".concat(macros.protein.grams, "g");
      if (carbsValue) carbsValue.textContent = "".concat(macros.carbs.grams, "g");
      if (fatValue) fatValue.textContent = "".concat(macros.fat.grams, "g");

      // Show the results div
      resultsDiv.style.display = "flex";

      // Bind the recalculate button
      var recalculateBtn = resultsDiv.querySelector(".recalculate-btn");
      if (recalculateBtn) {
        recalculateBtn.addEventListener("click", this.showForm.bind(this));
      }
      this.hideError();
    }
  }, {
    key: "showForm",
    value: function showForm() {
      var form = this.querySelector("#calories-form");
      var resultsDiv = this.querySelector("#results");
      if (!form || !resultsDiv) return;

      // Hide results and show form
      resultsDiv.style.display = "none";
      resultsDiv.innerHTML = ""; // Clear results content
      form.style.display = "block";
      this.isShowingResults = false;
      this.validateForm(); // Re-validate form state
    }
  }, {
    key: "showError",
    value: function showError(message) {
      // Create or update error message element
      var errorDiv = this.querySelector(".error-message");
      if (!errorDiv) {
        errorDiv = document.createElement("div");
        errorDiv.className = "error-message";

        // Insert error message before the form actions
        var formActions = this.querySelector(".form-actions");
        if (formActions) {
          formActions.parentNode.insertBefore(errorDiv, formActions);
        }
      }
      errorDiv.textContent = message;
      errorDiv.style.display = "block";
    }
  }, {
    key: "hideError",
    value: function hideError() {
      var errorDiv = this.querySelector(".error-message");
      if (errorDiv) {
        errorDiv.style.display = "none";
      }
    }
  }]);
  return CaloriesCalculator;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("calories-calculator", CaloriesCalculator);

// Function to check for gift cards in cart and update UI accordingly
function checkCartForGiftCards() {
  fetch("".concat(FoxTheme.routes.cart_url, ".js")).then(function (response) {
    return response.json();
  }).then(function (cartData) {
    // Check if cart has only gift cards
    var cartHasOnlyGiftCard = cartData.items.every(function (item) {
      return item.product_type === "Gift Cards";
    });

    // Update UI based on gift card presence
    var footerButtons = document.querySelector(".cart-drawer__footer .buttons-cart");
    var checkoutButton = document.querySelector("button[name='checkout']");
    if (cartHasOnlyGiftCard) {
      footerButtons === null || footerButtons === void 0 ? void 0 : footerButtons.classList.add("hidden");
      checkoutButton === null || checkoutButton === void 0 ? void 0 : checkoutButton.removeAttribute("disabled");
    } else {
      footerButtons === null || footerButtons === void 0 ? void 0 : footerButtons.classList.remove("hidden");
      checkoutButton === null || checkoutButton === void 0 ? void 0 : checkoutButton.setAttribute("disabled", "disabled");
    }
  })["catch"](function (error) {
    console.error("Error fetching cart data:", error);
  });
}

// Listen for cart updated event
document.addEventListener("cart:updated", checkCartForGiftCards);

// Listen for cart refresh event
document.addEventListener("cart:refresh", checkCartForGiftCards);

// Listen for cart refresh event
document.addEventListener("product-ajax:added", checkCartForGiftCards);

// Function to check and maintain delivery validation state on cart updates
function checkAndMaintainDeliveryState() {
  // Check if delivery information is still valid
  var postcode = sessionStorage.getItem("bmp-postcode");
  var deliveryDate = sessionStorage.getItem("bmp-delivery-date");
  var selectedTimeWindow = sessionStorage.getItem("bmp-selected-time-window");
  var customerTimeWindowSelected = sessionStorage.getItem("bmp-customer-time-window-selected");
  var hasValidDelivery = !!(postcode && deliveryDate && selectedTimeWindow && customerTimeWindowSelected);
  if (hasValidDelivery) {
    // Check cart total to ensure minimum spend is met
    fetch("/cart.js").then(function (response) {
      return response.json();
    }).then(function (cart) {
      var total = cart.total_price || 0;
      var meetsMinimumSpend = total >= (FoxTheme.minimum_spend || 6000); // Default to $60

      if (meetsMinimumSpend) {
        // Re-enable delivery frequency button
        var deliveryFrequencyButton = document.querySelector("cart-drawer .btn-cart-check-delevery");
        if (deliveryFrequencyButton) {
          deliveryFrequencyButton.removeAttribute("disabled");
        }

        // Update postcode button to show completed state
        var postCodeButton = document.querySelector("cart-drawer .btn-cart-check-postcode");
        if (postCodeButton) {
          postCodeButton.classList.add("checker-completed");
          var buttonText = postCodeButton.querySelector(".btn__text-current");
          // if (buttonText) {
          //   buttonText.innerHTML = postcode;
          // }

           var current_input = document.querySelector('cart-postcode-checker input').value.trim();
          if (this.deliveryData && this.deliveryData.find(function (item) {
            return item.postcode.toString() === current_input;
          })){
            var newpostcodeData = this.deliveryData.find(function (item) {
              return item.postcode.toString() === current_input;
            });
            const savedText = sessionStorage.getItem("bmp-postcode") || "";
            var newdeliveryDay = newpostcodeData.delivery_day;
            var newdeliveryDateArray = this.getNextDayOfTheWeek(newdeliveryDay);
            var newdeliveryDateString = newdeliveryDateArray[0];
            buttonText.innerHTML = `${savedText} - ${newdeliveryDateString}`;
            var ts_delivery_date = document.querySelector(".time-windows").getAttribute("delivery_date");
            if(ts_delivery_date){
              buttonText.innerHTML = `${savedText} - ${ts_delivery_date}`;
            }else{
              buttonText.innerHTML = `${savedText} - ${newdeliveryDateString}`;
            }
            }
          
        }

        // Enable checkout buttons
        document.querySelectorAll('cart-drawer button[name="checkout"]').forEach(function (btn) {
          btn.removeAttribute("disabled");
        });
        console.log("Delivery state maintained after cart update - checkout enabled");
      } else {
        console.log("Cart does not meet minimum spend, checkout remains disabled");
      }
    })["catch"](function (error) {
      console.error("Error checking cart state:", error);
    });
  } else {
    console.log("Delivery validation incomplete, checkout remains disabled");
  }
}

// Listen for cart updates to maintain delivery state
document.addEventListener("cart:updated", function () {
  // Add a small delay to ensure this runs after other cart update handlers
  setTimeout(checkAndMaintainDeliveryState, 200);
});
document.addEventListener("cart:refresh", function () {
  // Add a small delay to ensure this runs after other cart update handlers
  setTimeout(checkAndMaintainDeliveryState, 200);
});

// Function to open chat via shadow DOM
function openChatWithUs(event) {
  // If this is an anchor tag, prevent default navigation
  if (event && event.preventDefault) {
    event.preventDefault();
  }

  // Find the chat widget in shadow DOM
  var chatElement = document.querySelector("inbox-online-store-chat");
  if (chatElement && chatElement.shadowRoot) {
    var shadow = chatElement.shadowRoot;
    var button = shadow.querySelector("button.chat-toggle");
    if (button) {
      console.log("Chat button found, attempting to click");
      button.click();
      return true;
    } else {
      console.log("Chat button not found in shadow DOM");
    }
  } else {
    console.log("Chat element or shadow root not found");
  }
  return false;
}

// Find and attach event listeners to chat links
function findAndAttachChatLinks() {
  var allLinks = document.querySelectorAll("a");
  allLinks.forEach(function (link) {
    var linkText = link.textContent.toLowerCase();
    var href = link.getAttribute("href") || "";
    var ariaLabel = link.getAttribute("aria-label") || "";

    // Check if the link appears to be a chat link
    if (linkText.includes("chat with us") || href.includes("chat") || ariaLabel.includes("chat") || link.classList.contains("chat-link") || link.hasAttribute("data-chat")) {
      // Add click event listener
      link.addEventListener("click", openChatWithUs);
      console.log("Chat link detected and listener attached:", link);
    }
  });
}

// Initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", findAndAttachChatLinks);

// Klaviyo Newsletter Form Component
var KlaviyoNewsletterForm = /*#__PURE__*/function (_HTMLElement8) {
  _inherits(KlaviyoNewsletterForm, _HTMLElement8);
  var _super8 = _createSuper(KlaviyoNewsletterForm);
  function KlaviyoNewsletterForm() {
    _classCallCheck(this, KlaviyoNewsletterForm);
    return _super8.call(this);
  }
  _createClass(KlaviyoNewsletterForm, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.form = this.querySelector(".form-klaviyo-newsletter");
      if (this.form) {
        this.form.addEventListener("submit", this.onSubmit.bind(this));
      }
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(event) {
      var _this39 = this;
      event.preventDefault();
      var emailInput = this.form.querySelector('input[name="contact[email]"]');
      var submitButton = this.form.querySelector('button[type="submit"]');
      if (!emailInput || !emailInput.value.trim()) {
        this.showError("Please enter a valid email address");
        return;
      }
      var email = emailInput.value.trim();

      // Add loading state
      if (submitButton) {
        submitButton.setAttribute("aria-busy", "true");
        submitButton.disabled = true;
      }

      // Hide any existing messages
      this.hideMessages();
      var url = "https://a.klaviyo.com/client/subscriptions/?company_id=SB7pJR";
      var data = {
        data: {
          type: "subscription",
          attributes: {
            list_id: "U52fRL",
            email: email
          }
        }
      };
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Revision: "2023-06-15"
        },
        body: JSON.stringify(data)
      }).then(function (response) {
        if (response.ok) {
          _this39.showSuccess();
          // Clear the form
          emailInput.value = "";
        } else {
          // Handle specific error cases
          if (response.status === 409) {
            _this39.showAlreadySubscribed();
          } else {
            _this39.showError("There was an error subscribing. Please try again.");
          }
        }
      })["catch"](function (error) {
        console.error("Klaviyo subscription error:", error);
        _this39.showError("There was an error subscribing. Please try again.");
      })["finally"](function () {
        // Remove loading state
        if (submitButton) {
          submitButton.setAttribute("aria-busy", "false");
          submitButton.disabled = false;
        }
      });
    }
  }, {
    key: "showSuccess",
    value: function showSuccess() {
      var successElement = this.querySelector(".form_on_success");
      var fieldsetElement = this.querySelector(".fieldset-with-submit");
      if (successElement) {
        successElement.style.display = "block";
      }
      if (fieldsetElement) {
        fieldsetElement.style.display = "none";
      }
    }
  }, {
    key: "showError",
    value: function showError(message) {
      var errorElement = this.querySelector(".form_on_danger");
      if (errorElement) {
        // Update error message if needed
        var errorText = errorElement.querySelector("p");
        if (errorText && message) {
          errorText.innerHTML = "".concat(message);
        }
        errorElement.style.display = "block";
      }
    }
  }, {
    key: "showAlreadySubscribed",
    value: function showAlreadySubscribed() {
      var alreadySubscribedElement = this.querySelector("#Newsletter-error-subscribed--" + this.getCustomId());
      if (alreadySubscribedElement) {
        alreadySubscribedElement.classList.remove("hidden");
      }
    }
  }, {
    key: "hideMessages",
    value: function hideMessages() {
      // Hide all message elements
      var successElement = this.querySelector(".form_on_success");
      var errorElement = this.querySelector(".form_on_danger");
      var subscribedElement = this.querySelector('[id*="Newsletter-error-subscribed"]');
      if (successElement) {
        successElement.style.display = "none";
      }
      if (errorElement) {
        errorElement.style.display = "none";
      }
      if (subscribedElement) {
        subscribedElement.classList.add("hidden");
      }

      // Show the fieldset again if it was hidden
      var fieldsetElement = this.querySelector(".fieldset-with-submit");
      if (fieldsetElement) {
        fieldsetElement.style.display = "block";
      }
    }
  }, {
    key: "getCustomId",
    value: function getCustomId() {
      var form = this.querySelector("form");
      if (form && form.id) {
        return form.id.replace("ContactSubscribe-", "");
      }
      return "";
    }
  }]);
  return KlaviyoNewsletterForm;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element
if (!customElements.get("klaviyo-newsletter-form")) {
  customElements.define("klaviyo-newsletter-form", KlaviyoNewsletterForm);
}

// Recharge Logout Navigation Handler
// Check if we're in the Recharge portal
if (window.location.href.includes('/tools/recurring/portal')) {
  // Create a mutation observer to detect when the Recharge nav is loaded
  var observer = new MutationObserver(function (mutations) {
    // Check if the logout element exists after DOM changes
    var logoutNavElement = document.querySelector('a.recharge-navigation-logout');
    if (logoutNavElement) {
      // Add event listener directly to the logout link
      logoutNavElement.addEventListener('click', function (event) {
        event.preventDefault();
        window.location.href = '/account/logout';
      });

      // Disconnect observer since we've found what we need
      observer.disconnect();
      console.log('Recharge logout handler attached');
    }
  });

  // Start observing the document body for added nodes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Fallback cleanup - disconnect after 30 seconds if element never appears
  setTimeout(function () {
    return observer.disconnect();
  }, 30000);
}
if (window.location.pathname === "/cart") {
  window.location.replace("/");
}

/***/ }),

/***/ "./src/scss/main.scss":
/*!****************************!*\
  !*** ./src/scss/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/main": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/scss/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;